import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import toast from "react-hot-toast";
import { RiCloseFill, RiHistoryLine } from "react-icons/ri";
import { TbMessageCircleCheck } from "react-icons/tb";
import Loader from "../../components/common/Common/Loader";
import { GoArrowLeft } from "react-icons/go";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ADD_CONSERVATION,
  CONSERVATION_KANBAN,
  GLOBAL_SEARCH,
  LIST_CATEGORY,
  LIST_CONSERVATION,
  LIST_LOCATION,
  LIST_MATERIAL,
  lIST_NOTIFICATION,
  OBJECT_PIN,
  QR_LOCATION_MANAGMENT,
} from "../../constants/routers";
import AsyncSelect from "react-select/async";
import { HiOutlinePlus } from "react-icons/hi";
import replace from "../../assets/images/category/replace.png";
import Select from "react-select";
import { DatePicker, Space } from "antd";
import { CiCircleMinus } from "react-icons/ci";
import {
  addPinObject,
  assignUser,
  cancelSession,
  createSession,
  deletePinObject,
  detailNextDropdown,
  getObjectConservationDetails,
  listDegradationDropdown,
  listTreatmentDropdown,
  nextAndPreviousHandler,
  objectConservationCreation,
  objectConservationStatus,
  objectTreatmentCreation,
} from "../../api/actions/object";
import dayjs from "dayjs";
import { IoMdEye } from "react-icons/io";
import ReactImageGallery from "react-image-gallery";
import { GoPlusCircle } from "react-icons/go";
// import "react-image-gallery/styles/scss/image-gallery.scss"
import "react-image-gallery/styles/css/image-gallery.css";
import * as Yup from "yup";
import Commentdrawer from "../object-management/commentdrawer";
import { MdOutlineArrowBack } from "react-icons/md";
import {
  addItemToDB,
  clearPendingRequests,
  getPendingRequests,
} from "../../indexdb/indexdb";
import SimpleBackdrop from "../../components/common/Common/Buttonloader";
import { RiVipCrownFill } from "react-icons/ri";
import Objecthistorydrawer from "../object-management/Objecthistorydrawer";
import star from "../../assets/images/category/star.png";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import { capitalizeWord } from "../../components/common/Common/commonFunction";
import ImageEnlarge from "../../components/common/Common/imageEnlarge";
import { listUserDropdown, usedLastScreen } from "../../api/actions/user";
import {
  autoSaveToIndexedDB,
  clearAutoSavedFromIndexedDB,
} from "../../indexdb/autosaveIndex";
import { useSaving } from "../../store/SavinContext";
import { Md3dRotation } from "react-icons/md";
import "../../pages/objectPhotography/Objectphotography.scss";
import IOSSwitch from "../../components/common/Iosswitch";
import { createPortal } from "react-dom";
import { deepEqual } from "../../components/common/Common/deepEqual";
import { sendSessionClose } from "../../components/common/Common/sendSessionclose";
import OverRideAlert from "../../components/common/sweetAlert/overRideAlert";
import { LuPin, LuPinOff } from "react-icons/lu";
import { GrLinkNext, GrLinkPrevious } from "react-icons/gr";
import ConditionAssessment from "./conditonAssessment";
import { gets3Image } from "../../api/actions/S3sync";
import { RxCross2 } from "react-icons/rx";
import ConservationGallery from "./ConservationGallery";
import "./objectConsadd.scss";
import {
  filterGraphicalRepresentation,
  filterInvestigationDetails,
  hasOtherFieldValue,
  processProposedTreatment,
  processStratigraphic,
} from "./conservationUtils";

// const Model = ({ imageUrl }) => {
//     console.log(imageUrl, "3dimage");

//     const { scene } = useGLTF(imageUrl)
//     return <primitive scale={[0.8, 0.8, 0.8]} // scale down if too large
//         position={[0, -0.5, 0]}
//         rotation={[0, Math.PI / 2, 0]}
//         object={scene} />
// }

const Objectconsadd = ({ onCloseObject, objectId, fromList }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateS3, setUpdateS3] = useState(false);
  const [objectAccession, setObjectAccession] = useState();
  const [selectedDegradation, setSelectedDegradation] = useState();
  const [showImageEnlarge, setShowEnlargeImage] = useState({
    parentIndex: "",
    childIndex: "",
    imageIndex: "",
    imageIdTitle: "",
    image: "",
    show: false,
    title: "",
    isEdit: false,
  });
  const [buttonloader, setButtonloader] = useState({
    continue: false,
    next: false,
    save: false,
    complete: false,
  });
  const [action, setAction] = useState([]);
  const [actionNewValue, setActionNewValue] = useState();
  const [defaultAction, setDefaultAction] = useState([]);
  const [update, setUpdate] = useState(false);
  const [newValue, setNewValue] = useState();
  const [showContinue, setShowContinue] = useState(false);
  // const [isDetailFetchRef.current,setIsDetailFetch]=useState(false)
  const [addDraft, setAdddraft] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [isAutosave, setIsAutoSave] = useState(false);
  const [showAction, setShowAction] = useState(false);
  const [defaultProcedure, setDefaultProcedure] = useState([]);
  const [technicalImages, setTechnicalImages] = useState([]);
  const [showS3Gallery, setShowS3Gallery] = useState(false);
  const [nextAndPreviousLoad, setNextAndPreviousLoad] = useState({
    next: false,
    previous: false,
  });
  const [overRideMove, setOverRideMove] = useState({
    next: false,
    previous: false,
  });
  const [
    savedNextConservationDataOverRide,
    setSavedNextConsercationDataOverRide,
  ] = useState();
  const [typedAction, setTypedAction] = useState({
    value: "",
    valueState: false,
    indexOff: "",
  });
  const [actionUpdate, setActionUpdate] = useState(false);
  const [nextId, setNextId] = useState();
  const [previousId, setPreviousId] = useState();
  const refs = useRef([]);
  const stratRef = useRef(null);
  const isDetailFetchRef = useRef(false);
  const userData = JSON.parse(localStorage.getItem("user_info"));
  const navigate = useNavigate();
  // const id = fromList ? objectId : routeParams.id;
  const online = navigator.onLine;
  const [stratState, setStratState] = useState(false);
  const [degradation, setDegradation] = useState([]);
  const [defaultDegradation, setDefaultDeagradation] = useState([]);
  const stabilityCurrentRef = useRef();
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const [isOpenhistory, setIsOpenhistory] = React.useState(false);
  const location = useLocation();
  const [initialFormState, setInitialFormState] = useState(null);
  const [isOverRide, setIsOverRide] = useState(false);
  const [isOverideLoad, setIsOverRideLoad] = useState(false);
  const [hasFormChanged, setHasFormChanged] = useState(false);
  const [fromNotification] = useState(
    location.state?.fromNotification || false
  );
  const params = new URLSearchParams(window.location.search);

  const fromGlobalOpen = params.get("fromGlobalOpen");
  const fromGlobal = location?.state?.fromGlobal
    ? location?.state?.fromGlobal
    : fromGlobalOpen
    ? fromGlobalOpen
    : "";
  const encodedState = params.get("state");
  const stateObj = encodedState ? JSON.parse(atob(encodedState)) : null;
  const objectListFormik = location?.state?.objectListFormik
    ? location?.state?.objectListFormik
    : stateObj
    ? stateObj
    : "";
  const fromUsedObject = location?.state?.fromUsedObject;
  const fromLocation = location?.state?.fromLocation;
  const locationType = location?.state?.locationType;
  const floorPlanObjectId = location?.state?.floorPlanObjectId;
  const fromCategory = location?.state?.fromCategory;
  const fromMaterial = location?.state?.fromMaterial;
  const fromObjectTable = location?.state?.fromObjectTable
    ? location?.state?.fromObjectTable
    : "";
  const userUsedLastScreen = userData?.last_used_screen;
  const fromPinOpen = params.get("fromPinOpen");
  const fromPin = location?.state?.fromPin
    ? location?.state?.fromPin
    : fromPinOpen
    ? fromPinOpen
    : "";
  const [user, setUser] = useState([]);
  const [defaultUser, setDefaultUser] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const routeParams = useParams();

  const [id, setId] = useState(fromList ? objectId : routeParams.id);
  const { isSaving } = useSaving();

  const titleRowRef = useRef();
  const containerRowRef = useRef();
  const sessionRef = useRef(false);
  const sessionIdRef = useRef("");
  const isDetaillRef = useRef(false);
  const isChangedRef = useRef(false);
  const iSubmittedRef = useRef(false);
  const isAutoSaveRef = useRef(false);

  const toggleDrawerhistory = () => {
    setIsOpenhistory((prevState) => !prevState);
  };

  const convertBase64 = (resume) => {
    return new Promise((resolve, reject) => {
      if (!(resume instanceof Blob)) {
        reject(new Error("Invalid parameter: Expected a Blob."));
        return;
      }
      const fileReader = new FileReader();
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
      fileReader.readAsDataURL(resume);
    });
  };

  const formik = useFormik({
    validationSchema: Yup.object().shape({
      remarks: Yup.string().trim().required("Required"),
      // stabilization_guidelines: Yup.string().trim().required('Required'),
      // object_handling_guidelines: Yup.string().trim().required('Required')
    }),
    initialValues: {
      object_details: null,
      stability: "",
      is_emergency: false,
      remarks: "",
      stabilization_guidelines: "",
      object_handling_guidelines: "",
      graphical_represenatation: [],
      stratigraphic_assessment: [],
      physical_description: "",
      techinques_used: "",
      investigation_details: [
        {
          invasive_or_non_vasive: false,
          investigation_name: "",
          sample_details: "",
          result: "",
        },
      ],
      otherDimension: [],
      proposed_treatment: [
        {
          step: "1",
          selectedAction: "",
          degradation: "",
          selectedDegradation: null,
          temp_id: "",
          is_standered_procedure: false,
          conservation_materials: "",
          actionAdd: false,
          is_completed: false,
          viewLog: false,
          action: "",
          task: "",
          status: "",
          treatment_log: [],
        },
      ],
      recommended_storage: "",
      re_shoot: false,
      assignValue: null,
    },
    validate: (values) => {
      const errors = {};

      if (!values.is_emergency && !values.stability) {
        errors.stability = "Required";
      }
      return errors;
    },
    onSubmit: async (values) => {
      setIsAutoSave(false);
      await clearAutoSavedFromIndexedDB("conservation");

      setButtonloader({
        complete: true,
      });

      if (!addDraft) {
      }
      if (id) {
        values.id = id;
      }
      if (addDraft) {
        values.conservation_is_draft = true;
      }
      if (!values.stability) {
        delete values.stability;
      }
      values.conservation_is_draft = false;

      const payload = {
        ...values,
        session: sessionIdRef?.current,
        investigation_details: filterInvestigationDetails(
          values?.investigation_details
        ),
        graphical_represenatation: filterGraphicalRepresentation(
          values?.graphical_represenatation
        ),
        stratigraphic_assessment: processStratigraphic(
          values?.stratigraphic_assessment
        ),
        proposed_treatment: processProposedTreatment(
          values?.proposed_treatment
        ),
        session: sessionIdRef.current,
        // you can add other reversals like graphical_represenatation if needed
      };

      setSavedNextConsercationDataOverRide(payload);

      if (online) {
        objectConservationCreation(payload)((response) => {
          if (response?.status) {
            iSubmittedRef.current = true;
            sendSessionClose(
              "conservation",
              sessionIdRef?.current,
              id,
              isChangedRef.current,
              userData?.museum
            );
            setButtonloader({
              complete: false,
            });
            toast.success("Object conserved successfully!");
            setShowContinue(true);
            setLoading(false);

            if (showContinue) {
              if (fromList) {
                onCloseObject();
              } else if (fromLocation) {
                if (locationType) {
                  navigate(
                    `/${
                      userData.museum_name
                        ? userData?.museum_name?.split(" ").join("_")
                        : "Nefos"
                    }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
                  );
                } else {
                  navigate(
                    `/${
                      userData.museum_name
                        ? userData?.museum_name?.split(" ").join("_")
                        : "Nefos"
                    }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}`
                  );
                }
              } else {
                navigate(
                  `/${
                    userData?.museum_name
                      ? userData.museum_name.split(" ").join("_")
                      : "Nefos"
                  }/${CONSERVATION_KANBAN}`
                );
              }
            }
            if (formik?.values?.assignValue) {
              assignUser(formik?.values?.assignValue)((response) => {
                if (response?.status) {
                }
              });
            }
          } else {
            if (response?.status_code === 400 && response?.conflict) {
              setIsOverRide(true);
            }
            if (!response?.conflict) {
              toast.error(response?.message, {
                style: {
                  maxWidth: "500px",
                  whiteSpace: "pre-wrap", // allows multiline text
                  wordBreak: "break-word", // long words wrap
                  height: "auto",
                  padding: "12px 16px",
                },
              });
            }

            setButtonloader({
              complete: false,
            });
          }
        });
      } else {
        addItemToDB(values, "conservation")
          .then(() => {
            setButtonloader({
              complete: false,
            });
            toast.success(
              id
                ? "Object updated successfully!"
                : "Object created successfully!"
            );
            formik.resetForm();
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${CONSERVATION_KANBAN}`
            );
          })
          .catch((error) => {
            setButtonloader({
              complete: false,
            });
            console.error("Failed to add item to IndexedDB:", error);
            toast.error("Failed to save data locally.");
          });
      }
    },
  });

  const [impFields] = useState({
    remarks: formik?.values?.remarks,
    stability: formik?.values?.stability,
  });

  const continueSubmitHandler = async (value) => {
    if (value === "continue") {
      formik.validateForm().then((errors) => {
        if (Object.keys(errors).length > 0) {
          // Display validation errors
          formik.setTouched(
            Object.keys(errors).reduce((acc, key) => {
              acc[key] = true;
              return acc;
            }, {})
          );
        } else {
          setShowContinue(true);
        }
      });
    }
  };

  const onConervesubmitHandler = async () => {
    setIsAutoSave(false);
    await clearAutoSavedFromIndexedDB("conservation");

    const updatedValues = { ...formik.values };
    if (id) {
      updatedValues.id = id;
    }
    if (!updatedValues.stability) {
      delete updatedValues.stability;
    }

    updatedValues.conservation_is_draft = true;

    const payload = {
      ...updatedValues,
      investigation_details: filterInvestigationDetails(
        updatedValues?.investigation_details
      ),
      graphical_represenatation: filterGraphicalRepresentation(
        updatedValues?.graphical_represenatation
      ),
      stratigraphic_assessment: processStratigraphic(
        updatedValues?.stratigraphic_assessment
      ),
      proposed_treatment: processProposedTreatment(
        updatedValues?.proposed_treatment
      ),
      session: sessionIdRef.current,
      // you can add other reversals like graphical_represenatation if needed
    };
    formik.validateForm().then((errors) => {
      if (Object.keys(errors).length > 0) {
        // Display validation errors
        formik.setTouched(
          Object.keys(errors).reduce((acc, key) => {
            acc[key] = true;
            return acc;
          }, {})
        );
      } else {
        setButtonloader({
          save: true,
        });

        setSavedNextConsercationDataOverRide(payload);
        if (online) {
          objectConservationCreation(payload)((response) => {
            if (response?.status) {
              iSubmittedRef.current = true;
              sendSessionClose(
                "conservation",
                sessionIdRef?.current,
                id,
                isChangedRef.current,
                userData?.museum
              );
              setButtonloader({
                save: false,
              });
              setLoading(false);
              if (fromList) {
                onCloseObject();
              } else if (fromLocation) {
                if (locationType) {
                  navigate(
                    `/${
                      userData.museum_name
                        ? userData?.museum_name?.split(" ").join("_")
                        : "Nefos"
                    }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
                  );
                } else {
                  navigate(
                    `/${
                      userData.museum_name
                        ? userData?.museum_name?.split(" ").join("_")
                        : "Nefos"
                    }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}`
                  );
                }
              } else {
                navigate(
                  `/${
                    userData.museum_name
                      ? userData?.museum_name?.split(" ").join("_")
                      : "Nefos"
                  }/${CONSERVATION_KANBAN}`
                );
              }
              const currentStatus =
                updatedValues?.object_details?.conservation_status;

              let nextStatus = currentStatus;

              // 🚫 once in conservation → locked forever
              if (currentStatus === "in_conservation") {
                nextStatus = "in_conservation";
              }

              // to_do → in_conditional_assessment
              else if (currentStatus === "to_do") {
                if (hasOtherFieldValue(updatedValues)) {
                  nextStatus = "in_conservation";
                } else if (
                  updatedValues?.remarks &&
                  (updatedValues?.stability || updatedValues?.is_emergency)
                ) {
                  nextStatus = "in_conditional_assessment";
                }
              }

              // in_conditional_assessment → in_conservation
              else if (
                currentStatus === "in_conditional_assessment" &&
                hasOtherFieldValue(updatedValues)
              ) {
                nextStatus = "in_conservation";
              }
              if (nextStatus !== currentStatus) {
                objectConservationStatus({
                  id,
                  conservation_status: nextStatus,
                })((response) => {
                  if (response?.status) {
                    // success
                  }
                });
              }

              if (formik?.values?.assignValue) {
                assignUser(formik?.values?.assignValue)((response) => {
                  if (response?.status) {
                  }
                });
              }
            } else {
              iSubmittedRef.current = false;
              if (response?.status_code === 400 && response?.conflict) {
                setIsOverRide(true);
              }
              if (!response?.conflict) {
                toast.error(response?.message, {
                  style: {
                    maxWidth: "500px",
                    whiteSpace: "pre-wrap", // allows multiline text
                    wordBreak: "break-word", // long words wrap
                    height: "auto",
                    padding: "12px 16px",
                  },
                });
              }
              setButtonloader({
                save: false,
              });
              setLoading(false);
            }
          });
        } else {
          addItemToDB(updatedValues, "conservation")
            .then(() => {
              setButtonloader({
                save: false,
              });
              toast.success(
                id
                  ? "Object updated successfully!"
                  : "Object created successfully!"
              );
              formik.resetForm();
              navigate(
                `/${
                  userData.museum_name
                    ? userData?.museum_name?.split(" ").join("_")
                    : "Nefos"
                }/${CONSERVATION_KANBAN}`
              );
            })
            .catch((error) => {
              setButtonloader({
                save: false,
              });
              console.error("Failed to add item to IndexedDB:", error);
              toast.error("Failed to save data locally.");
            });
        }
      }
    });
  };

  const logDateHandler = (dateValue, proposedIndex, logIndex) => {
    setIsAutoSave(true);
    const formatDate = (date) => {
      if (date) {
        const nativeDate = date.toDate();
        const [day, month, year] = nativeDate
          .toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
          .split("/"); // Split the date by "/"

        return `${year}-${month}-${day}`; // Reformat into DD-MM-YYYY
      }
      return ""; // Return an empty string if date is invalid
    };
    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList[proposedIndex].treatment_log[logIndex].date =
      formatDate(dateValue);

    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const procedureHandler = (e, indexofstandard) => {
    setIsAutoSave(true);
    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList[indexofstandard].is_standered_procedure = e?.target?.checked;
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const statusChangeHandler = (e, proposedIndex) => {
    setIsAutoSave(true);
    const proposedList = [...formik?.values?.proposed_treatment];

    if (proposedList[proposedIndex]?.treatment_log?.length === 0) {
      proposedList[proposedIndex].treatment_log?.push({
        date: "",
        notes: "",
        evidence: [
          {
            image: "",
          },
        ],
      });
    }

    e.value === "Started"
      ? (proposedList[proposedIndex].viewLog = true)
      : (proposedList[proposedIndex].viewLog = false);
    proposedList[proposedIndex].status = e.value;
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const removeLogImageChangeHandler = (
    proposdeIndex,
    logIndex,
    evidIndexofImage
  ) => {
    setIsAutoSave(true);
    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList[proposdeIndex]?.treatment_log[logIndex]?.evidence.splice(
      evidIndexofImage,
      1
    );
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const addStepCompleteHandler = (proposdeIndex) => {
    setIsAutoSave(true);
    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList[proposdeIndex].status = "Done";
    proposedList[proposdeIndex].viewLog = false;
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
    proposedList[proposdeIndex].is_completed = true;
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };
  const addLogImageChangeHandler = (e, proposedIndex, logIndex, evidIndex) => {
    const file = e.target.files[0];
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed!");
      e.target.value = ""; // Reset invalid selection
      return;
    }
    setIsAutoSave(true);
    const proposedList = [...formik?.values?.proposed_treatment];
    convertBase64(e.target.files[0])
      .then((resp) => {
        setShowEnlargeImage({
          ...showImageEnlarge,
          image: resp,
        });
        proposedList[proposedIndex].treatment_log[logIndex].evidence[
          evidIndex
        ].image = resp;
        formik?.setValues({
          ...formik?.values,
          proposed_treatment: proposedList,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    const fileInput = document.getElementById(
      `file-input-treatment-${proposedIndex}-${logIndex}-${evidIndex}`
    );

    if (fileInput) {
      fileInput.value = "";
    }
  };

  const removedProposedHandler = (proposedIndex, childIndex) => {
    setIsAutoSave(true);
    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList[proposedIndex]?.treatment_log.splice(childIndex, 1);
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const AddProposedHandler = (proposdeIndex) => {
    setIsAutoSave(true);

    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList[proposdeIndex]?.treatment_log?.unshift({
      date: "",
      notes: "",
      evidence: [
        {
          image: "",
        },
      ],
    });
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const addProposeLogImageHandler = (proposedIndex, logIndex) => {
    setIsAutoSave(true);

    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList[proposedIndex]?.treatment_log[logIndex]?.evidence?.unshift({
      image: "",
    });

    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const viewLogHandler = (proposedIndex) => {
    setIsAutoSave(true);

    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList[proposedIndex].viewLog =
      proposedList[proposedIndex].viewLog === true ? false : true;
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const removeProposedHandler = (proposedIndex) => {
    setIsAutoSave(true);

    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList?.splice(proposedIndex, 1);
    const updatedList = proposedList.map((item, index) => ({
      ...item,
      step: index + 1,
    }));
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: updatedList,
    });
  };

  const actionValueAddHandler = (e, proposedIndex) => {
    setUser(defaultUser);

    setIsAutoSave(true);

    setTypedAction({
      value: "",
      valueState: false,
    });
    const proposedList = [...formik?.values?.proposed_treatment];
    const matchedItem = defaultProcedure?.find(
      (item) => String(item?.action) === String(e?.value)
    );

    if (matchedItem) {
      proposedList[proposedIndex].status = "To-do";
      proposedList[proposedIndex].action = e.value;
      proposedList[proposedIndex].selectedAction = e;
      proposedList[proposedIndex].conservation_materials =
        matchedItem.conservation_materials;
      proposedList[proposedIndex].task = matchedItem.task;
    } else {
      proposedList[proposedIndex].conservation_materials = "";
      proposedList[proposedIndex].task = "";
      proposedList[proposedIndex].status = "To-do";
      proposedList[proposedIndex].action = e.value;
      proposedList[proposedIndex].selectedAction = e;
    }

    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const conservationMaterialHandler = (
    materialValue,
    indexofPropodedMaterial
  ) => {
    setIsAutoSave(true);
    const proposedList = [...formik?.values?.proposed_treatment];

    proposedList[indexofPropodedMaterial].conservation_materials =
      materialValue?.target?.value;
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const degradationChangeHandler = (degradationValue, proposdeIndex) => {
    setIsAutoSave(true);

    const assessmentList = [...formik?.values?.stratigraphic_assessment];
    const proposedList = [...formik?.values?.proposed_treatment];

    proposedList[proposdeIndex].selectedDegradation = {
      value: degradationValue?.value,
      label: `${degradationValue?.label} (${degradationValue?.assessment_name})`,
      temp_id: degradationValue?.temp_id,
    };

    if (degradationValue?.temp_id) {
      assessmentList[degradationValue?.assesmentIndex].assessment_details[
        degradationValue?.detailIndex
      ].temp_id = degradationValue?.temp_id;
      proposedList[proposdeIndex].temp_id = degradationValue.temp_id;
      proposedList[proposdeIndex].degradation = "";
      formik?.setValues({
        ...formik?.values,
        proposed_treatment: proposedList,
        stratigraphic_assessment: assessmentList,
      });
    } else {
      proposedList[proposdeIndex].degradation = degradationValue?.value;

      formik?.setValues({
        ...formik?.values,
        proposed_treatment: proposedList,
      });
    }
  };

  const addActionChangeHandler = (e, proposdeIndex) => {
    setIsAutoSave(true);

    if (refs.current[proposdeIndex]) {
      refs.current[proposdeIndex].focus();
    }
    if (e.key === "Enter") {
      // e.preventDefault()
      setTypedAction({
        value: e.target.value,
        valueState: true,
        indexOff: proposdeIndex,
      });

      const proposedList = [...formik?.values?.proposed_treatment];
      objectTreatmentCreation({
        action_name: e.target.value,
        museum: userData?.museum,
      })((response) => {
        if (response?.status) {
          setActionUpdate(!actionUpdate);
          toast.success("Treatment action created successfully !");
          proposedList[proposdeIndex].actionAdd = false;
          proposedList[proposdeIndex].status = "To-do";

          formik?.setValues({
            ...formik?.values,
            proposed_treatment: proposedList,
          });
        } else {
          toast.error(response?.response?.data?.errors?.action);
        }
      });
    }
  };
  const backToTreatmentHandler = (proposdeIndex) => {
    setIsAutoSave(true);

    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList[proposdeIndex].actionAdd = false;
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };
  const addTreatmentActionHandler = (proposdeIndex) => {
    setIsAutoSave(true);

    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList[proposdeIndex].actionAdd = true;
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const addProposedTreatmentHandler = (proposdeIndex) => {
    setIsAutoSave(true);

    const proposedList = [...formik?.values?.proposed_treatment];
    proposedList?.push({
      step: proposdeIndex + 2,
      selectedAction: "",
      selectedDegradation: "",
      actionAdd: false,
      is_completed: false,
      viewLog: false,
      action: "",
      task: "",
      status: "",
      treatment_log: [],
    });
    formik?.setValues({
      ...formik?.values,
      proposed_treatment: proposedList,
    });
  };

  const removestrategicEvidenceImageChangeHandler = (
    assesmentIndex,
    detailIndex,
    evidIndex
  ) => {
    setIsAutoSave(true);

    const startegicList = [...formik?.values?.stratigraphic_assessment];
    startegicList[assesmentIndex]?.assessment_details[
      detailIndex
    ]?.evidence_images?.splice(evidIndex, 1);
    formik.setValues({
      ...formik.values,
      stratigraphic_assessment: startegicList,
    });
  };

  const strategicEvidenceImageChangeHandler = (
    e,
    assesmentIndex,
    detailIndex,
    evidIndex
  ) => {
    const file = e.target.files[0];
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed!");
      e.target.value = ""; // Reset invalid selection
      return;
    }
    setIsAutoSave(true);

    const startegicList = [...formik?.values?.stratigraphic_assessment];
    convertBase64(e.target.files[0])
      .then((resp) => {
        setShowEnlargeImage({
          ...showImageEnlarge,
          image: resp,
        });
        startegicList[assesmentIndex].assessment_details[
          detailIndex
        ].evidence_images[evidIndex].image = resp;
        startegicList[assesmentIndex].assessment_details[
          detailIndex
        ].evidence_images[evidIndex].caption = file.name;

        formik.setValues({
          ...formik.values,
          stratigraphic_assessment: startegicList,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    const fileInput = document.getElementById(
      `file-input-${assesmentIndex}-${detailIndex}-${evidIndex}`
    );

    if (fileInput) {
      fileInput.value = "";
    }
  };

  const strategicEvidenceImageAddHandler = (
    strategicIndex,
    AssesmentDetailIndex
  ) => {
    setIsAutoSave(true);

    const strategicList = [...formik?.values?.stratigraphic_assessment];
    if (
      strategicList[strategicIndex]?.assessment_details[AssesmentDetailIndex]
        ?.evidence_images.length < 10
    ) {
      strategicList[strategicIndex]?.assessment_details[
        AssesmentDetailIndex
      ]?.evidence_images?.unshift({
        image: "",
        caption: "",
        image_change: false,
      });
    }

    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: strategicList,
    });
  };
  const strategicDetailRemoveHandler = (strategicIndex, childIndex) => {
    setIsAutoSave(true);

    const strategicList = [...formik?.values?.stratigraphic_assessment];
    strategicList[strategicIndex]?.assessment_details?.splice(childIndex, 1);
    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: strategicList,
    });
  };

  const addDetailOnOutsideHandler = (strategicIndex, childIndex, key) => {
    setIsAutoSave(true);

    const strategicList = [...formik?.values?.stratigraphic_assessment];
    strategicList[strategicIndex].assessment_details[childIndex][key] = false;
    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: strategicList,
    });
  };
  const doubleClickStrategicHandler = (strategicIndex, childIndex, key) => {
    setIsAutoSave(true);

    const strategicList = [...formik?.values?.stratigraphic_assessment];
    strategicList[strategicIndex].assessment_details[childIndex][key] === true
      ? (strategicList[strategicIndex].assessment_details[childIndex][
          key
        ] = false)
      : (strategicList[strategicIndex].assessment_details[childIndex][
          key
        ] = true);
    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: strategicList,
    });
  };

  const strategicDetailsAddHandler = (strategicIndex, assessment_name) => {
    setIsAutoSave(true);

    const strategicList = [...formik?.values?.stratigraphic_assessment];
    strategicList[strategicIndex]?.assessment_details?.unshift({
      locationInput: true,
      detailinput: true,
      degredationInput: true,
      degradation: "",
      details: "",
      location: "",
      description: "",
      caption: "",
      evidence_images: [
        {
          image: "",
          caption: "",
          image_change: false,
        },
      ],
    });

    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: strategicList,
    });
  };

  const stratigraphicAddhandler = (value) => {
    setIsAutoSave(true);

    const stratigraphicList = formik?.values?.stratigraphic_assessment.map(
      (item) => ({
        ...item,
        active: false, // Set all existing items' active property to false
      })
    );

    stratigraphicList.unshift({
      active: true,
      doubleClickActive: false,
      assessment_name: value,
      assessment_type: "New layer",
      assessment_materials: [],
      assessment_stability: null,
      assessment_is_emergency: false,
      selectedMaterial: [],
      selectedStability: null,
      assessment_details: [
        {
          locationInput: true,
          detailinput: true,
          description: "",
          degredationInput: true,
          degradation: "",
          degradationUid: "",
          details: "",
          location: "",
          caption: "",
          evidence_images: [
            {
              image: "",
              caption: "",
              image_changed: false,
            },
          ],
        },
      ],
    });
    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: stratigraphicList,
    });
  };

  const changeStratNameHandler = (indexOfassesment) => {
    setIsAutoSave(true);

    const stratigraphicList = [...formik?.values?.stratigraphic_assessment];
    stratigraphicList[indexOfassesment].doubleClickActive = true;
    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: stratigraphicList,
    });
  };

  const openStratButton = (indexOfassesment) => {
    setIsAutoSave(true);

    const stratigraphicList = [...formik?.values?.stratigraphic_assessment];
    stratigraphicList[indexOfassesment].active === true
      ? (stratigraphicList[indexOfassesment].active = false)
      : (stratigraphicList[indexOfassesment].active = true);
    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: stratigraphicList,
    });
  };

  const stratNameChangeHandler = (value, indexOfassesment, assessmentValue) => {
    setIsAutoSave(true);

    const stratigraphicList = [...formik?.values?.stratigraphic_assessment];
    const proposedList = [...formik?.values?.proposed_treatment];

    const assessmentDetailsListId =
      stratigraphicList[indexOfassesment].assessment_details;
    if (assessmentDetailsListId && degradation?.length > 0) {
      const updatedNewDegradation = degradation?.map((degradationItem) => {
        const matchingAssessment = assessmentDetailsListId.find(
          (assessment) =>
            (degradationItem.value &&
              assessment.id === degradationItem.value) ||
            (degradationItem.temp_id &&
              assessment.degradationUid === degradationItem.temp_id)
        );
        if (matchingAssessment) {
          return {
            ...degradationItem,
            assessment_name: value, // Update assessment_name if match found
          };
        }

        return degradationItem;
      });

      setDegradation(updatedNewDegradation);
    }

    if (assessmentDetailsListId && proposedList?.length > 0) {
      const updatedProposeTreatment = proposedList?.map((proposedItem) => {
        const matchingAssessment = assessmentDetailsListId?.find(
          (assesmentItem) =>
            assesmentItem?.id === proposedItem?.degradation ||
            assesmentItem?.degradationUid ===
              proposedItem?.selectedDegradation?.temp_id
        );

        if (matchingAssessment) {
          if (proposedItem?.selectedDegradation) {
            return {
              ...proposedItem,
              selectedDegradation: {
                ...proposedItem?.selectedDegradation,
                label: `${
                  proposedItem.selectedDegradation.label.split(" (")[0]
                } (${value})`, // Preserve original degradation text, only update assessment
              },
            };
          } else {
            return {
              ...proposedItem,
              assessment_name: value,
            };
          }
        }

        return proposedItem;
      });
      stratigraphicList[indexOfassesment].assessment_name = value;
      formik?.setValues({
        ...formik?.values,
        stratigraphic_assessment: stratigraphicList,
        proposed_treatment: updatedProposeTreatment,
      });
      return;
    }

    stratigraphicList[indexOfassesment].assessment_name = value;
    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: stratigraphicList,
    });
  };

  const removeGraphicHandler = (indexOfParent) => {
    setIsAutoSave(true);

    const graphicList = [...formik?.values?.graphical_represenatation];
    graphicList?.splice(indexOfParent, 1);
    formik.setValues({
      ...formik.values,
      graphical_represenatation: graphicList,
    });
  };

  const graphicImageAddhandler = (e, graphicIndex) => {
    const file = e.target.files[0];
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed!");
      e.target.value = ""; // Reset invalid selection
      return;
    }
    setIsAutoSave(true);

    const graphicList = [...formik?.values?.graphical_represenatation];
    convertBase64(e.target.files[0])
      .then((resp) => {
        setShowEnlargeImage({
          ...showImageEnlarge,
          image: resp,
        });
        graphicList[graphicIndex].image = resp;

        formik.setValues({
          ...formik.values,
          graphical_represenatation: graphicList,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    const fileInput = document.getElementById(
      `file-input-graph-${graphicIndex}`
    );
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const graphicRepresentHandler = () => {
    setIsAutoSave(true);

    const graphicList = [...formik?.values?.graphical_represenatation];
    graphicList?.unshift({
      image: "",
    });
    formik?.setValues({
      ...formik?.values,
      graphical_represenatation: graphicList,
    });
  };

  const stabilityHandler = (value) => {
    setIsAutoSave(true);

    formik.setValues({
      ...formik.values,
      stability: formik.values.stability === value ? "" : value,
      is_emergency: false,
    });
  };
  const isEmeregncyHandler = (value) => {
    setIsAutoSave(true);

    formik.setValues({
      ...formik?.values,
      is_emergency: formik?.values?.is_emergency === true ? false : true,
      stability: "",
    });
  };

  const handleBack = async (type) => {
    if (type === "discard") {
      await clearAutoSavedFromIndexedDB("conservation");
    }
    if (fromNotification) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${lIST_NOTIFICATION}`
      );
    } else if (fromList) {
      onCloseObject();
    } else if (fromCategory) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${LIST_CATEGORY}`
      );
    } else if (fromLocation) {
      if (locationType) {
        navigate(
          `/${
            userData.museum_name
              ? userData?.museum_name?.split(" ").join("_")
              : "Nefos"
          }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
        );
      } else {
        navigate(
          `/${
            userData.museum_name
              ? userData?.museum_name?.split(" ").join("_")
              : "Nefos"
          }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}`
        );
      }
    } else if (fromMaterial) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${LIST_MATERIAL}`
      );
    } else if (fromGlobal) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${GLOBAL_SEARCH}`
      );
    } else if (fromObjectTable) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${LIST_CONSERVATION}`
      );
    } else if (fromPin) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${OBJECT_PIN}`
      );
    } else {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${CONSERVATION_KANBAN}`
      );
    }
    setUpdate(!update);
  };

  const removeStratighicHandler = (assesmentIndex) => {
    setIsAutoSave(true);

    const startegicList = [...formik?.values?.stratigraphic_assessment];
    startegicList.splice(assesmentIndex, 1);
    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: startegicList,
    });
  };

  useEffect(() => {
    const { remarks, stability } = formik?.values || {};
    if (remarks === "" && stability === "") {
      setShowContinue(false);
    } else {
      setShowContinue(true);
    }
  }, [impFields.remarks, impFields.stability]);

  useEffect(() => {
    setLoading(true);
    if (id && !isSaving.conservation && !isDetailFetchRef.current) {
      getObjectConservationDetails({ id })((response) => {
        const dataValue = response?.data;
        setObjectAccession(dataValue?.object_details?.accession_number);

        const updatedInvestigationData =
          dataValue?.conservation_details?.investigation_details;

        const updatedData =
          dataValue?.conservation_details?.proposed_treatment?.map((item) => ({
            ...item,
            treatment_log:
              item?.treatment_log?.length > 0
                ? item?.treatment_log
                : item.status === "Started" ||
                  item.status === "In progress" ||
                  item.status === "Done"
                ? [
                    {
                      date: "",
                      notes: "",
                      evidence: [
                        {
                          image: "",
                        },
                      ],
                    },
                  ]
                : [],
            viewLog: item.status === "Started" ? true : false,
          }));
        if (response?.status) {
          iSubmittedRef.current = false;
          const sessionOpenValues = {
            museum: userData?.museum,
            museum_object: id,
            screen: "conservation",
            status: "open",
            is_changes_made: false,
          };

          createSession(sessionOpenValues)((response) => {
            if (response?.status) {
              sessionIdRef.current = response?.data?.id;
              sessionRef.current = true;
              localStorage.setItem("conservationsession", response?.data?.id);
            }
          });

          isDetaillRef.current = true;
          setSelectedUser({
            value: dataValue?.object_details?.object_assigned,
            label: dataValue?.object_details?.object_assigned_name,
          });
          setDefaultProcedure(
            dataValue?.conservation_details?.default_standered_procedure
          );
          setShowContinue(
            dataValue?.conservation_details?.remarks &&
              (dataValue?.conservation_details?.stability ||
                dataValue?.conservation_details?.is_emergency)
          );

          try {
            const newFormValues = {
              ...formik?.values,
              object_pinned_id: dataValue?.object_details?.object_pinned_id,
              is_pinned: dataValue?.object_details?.is_pinned,
              is_emergency: dataValue?.conservation_details?.is_emergency,
              object_details: dataValue?.object_details,
              remarks: dataValue?.conservation_details?.remarks,
              graphical_represenatation:
                dataValue?.conservation_details?.graphical_represenatation,
              invasive_or_non_vasive: dataValue?.conservation_details
                ?.invasive_or_non_vasive
                ? dataValue?.conservation_details?.invasive_or_non_vasive
                : false,
              // investigation_id: dataValue?.conservation_details?.investigation_id,
              object_handling_guidelines:
                dataValue?.conservation_details?.object_handling_guidelines,
              investigation_details:
                dataValue?.conservation_details?.investigation_details
                  ?.length === 0
                  ? [
                      {
                        invasive_or_non_vasive: false,
                        sample_details: "",
                        investigation_name: "",
                        result: "",
                      },
                    ]
                  : updatedInvestigationData,
              proposed_treatment:
                dataValue?.conservation_details?.proposed_treatment?.length ===
                0
                  ? [
                      {
                        step: "1",
                        selectedAction: "",
                        selectedDegradation: null,
                        actionAdd: false,
                        degradation: "",
                        is_standered_procedure: false,
                        conservation_materials: "",
                        is_completed: false,
                        viewLog: false,
                        action: "",
                        task: "",
                        status: "",
                        temp_id: "",
                        treatment_log: [],
                      },
                    ]
                  : updatedData,
              re_shoot: dataValue?.conservation_details?.re_shoot,
              recommended_storage:
                dataValue?.conservation_details?.recommended_storage,
              result: dataValue?.conservation_details?.result,
              sample_details: dataValue?.conservation_details?.sample_details,
              stability: dataValue?.conservation_details?.stability,
              stabilization_guidelines:
                dataValue?.conservation_details?.stabilization_guidelines,
              stratigraphic_assessment:
                dataValue?.conservation_details?.stratigraphic_assessment?.map(
                  (item) => {
                    return {
                      ...item,
                      selectedMaterial: item?.assessment_materials,
                      assessment_materials: item?.assessment_materials?.map(
                        (item) => item?.value
                      ),
                    };
                  }
                ),

              physical_description:
                dataValue?.conservation_details?.physical_description,
              techinques_used: dataValue?.conservation_details?.techinques_used,
            };
            formik?.setValues(newFormValues);
            setInitialFormState(structuredClone(newFormValues));
            setLoading(false);
          } catch (err) {
            console.log(err, "error_test");
          }
        }
      });
    }
  }, [update, isSaving.conservation, id, isDetailFetchRef.current]);
  useEffect(() => {
    if (objectAccession) {
      gets3Image({
        page: 1,
        folder_name: objectAccession,
        museum: userData?.museum,
        image_type: "technical_images",
      })((response) => {
        if (response?.status) {
          setTechnicalImages(response?.data);
        }
      });
    }
  }, [updateS3, objectAccession]);

  useEffect(() => {
    if (id) {
      setNextId(null);
      setPreviousId(null);
      const objectListdata = {
        ...objectListFormik,
        current_object: id,
        screen: fromPin ? "pinned_objects" : "conservation",
        is_global_search: fromGlobal ? true : false,
      };

      if (fromUsedObject || fromLocation) {
        delete objectListdata.screen;
        delete objectListdata.is_global_search;
      }

      nextAndPreviousHandler(objectListdata)((response) => {
        if (response?.status) {
          if (response?.data?.next_object) {
            setNextId(response?.data?.next_object);
          }
          if (response?.data?.previous_object) {
            setPreviousId(response?.data?.previous_object);
          }
        }
      });
    }
  }, [id, update]);

  useEffect(() => {
    listTreatmentDropdown({ page: 1, limit: 10, museum_id: userData?.museum })(
      (response) => {
        if (response?.status) {
          const standardIds = defaultProcedure?.map((value) => value.action);

          const updatedActionData = response?.data?.map((actionValue) => ({
            ...actionValue,
            is_standard: standardIds
              .map(String)
              .includes(String(actionValue.value)),
          }));

          if (response?.data?.length === 0) {
            setShowAction(true);
          } else {
            setShowAction(false);
          }

          if (typedAction.valueState) {
            setIsAutoSave(true);

            const matchingElement = response?.data.find(
              (li) => li?.label === capitalizeWord(typedAction?.value)
            );
            const matchingValue = matchingElement?.value;

            // Ensure the selectedAction key exists in the object
            const proposedList = [...formik?.values?.proposed_treatment].map(
              (item, index) => {
                if (index === typedAction.indexOff) {
                  return {
                    ...item,
                    action: matchingValue,
                    selectedAction: {
                      value: matchingValue,
                      label: matchingElement?.label,
                    },
                  };
                }
                return item;
              }
            );

            formik?.setValues({
              ...formik?.values,
              proposed_treatment: proposedList,
            });

            setAction(updatedActionData);
            setDefaultAction(updatedActionData);
          } else {
            setAction(updatedActionData);
            setDefaultAction(updatedActionData);
          }
        }
      }
    );
  }, [actionUpdate, defaultProcedure, typedAction]);

  const investigationRemoveHandler = (investigationIndex) => {
    setIsAutoSave(true);
    const investigationList = [...formik?.values?.investigation_details];
    investigationList?.splice(investigationIndex, 1);
    formik?.setValues({
      ...formik?.values,
      investigation_details: investigationList,
    });
  };

  const investigationAddHandler = () => {
    const investigationList = [...formik?.values?.investigation_details];
    setIsAutoSave(true);

    investigationList?.unshift({
      invasive_or_non_vasive: false,
      sample_details: "",
      result: "",
      investigation_name: "",
    });

    formik?.setValues({
      ...formik?.values,
      investigation_details: investigationList,
    });
  };
  const investResultHandler = (value, investigationChangeIndex) => {
    setIsAutoSave(true);
    const invasValue = value?.target?.value;

    const investigationList = [...formik?.values?.investigation_details];
    investigationList[investigationChangeIndex].result = invasValue;

    formik?.setValues({
      ...formik?.values,
      investigation_details: investigationList,
    });
  };

  const investNameChangeHandler = (value, investigationChangeIndex) => {
    setIsAutoSave(true);
    const invasValue = value?.target?.value;
    const investigationList = [...formik?.values?.investigation_details];
    investigationList[investigationChangeIndex].investigation_name = invasValue;

    formik?.setValues({
      ...formik?.values,
      investigation_details: investigationList,
    });
  };

  const investDetailHandler = (value, investigationChangeIndex) => {
    setIsAutoSave(true);
    const invasValue = value?.target?.value;

    const investigationList = [...formik?.values?.investigation_details];
    investigationList[investigationChangeIndex].sample_details = invasValue;

    formik?.setValues({
      ...formik?.values,
      investigation_details: investigationList,
    });
  };

  const invasiveChangeHandler = (value, investigationChangeIndex) => {
    setIsAutoSave(true);
    const invasValue = value?.target?.checked;

    const investigationList = [...formik?.values?.investigation_details];
    investigationList[investigationChangeIndex].invasive_or_non_vasive =
      invasValue;

    formik?.setValues({
      ...formik?.values,
      investigation_details: investigationList,
    });
  };

  const objectData = formik?.values?.object_details;

  function deepEqual(a, b) {
    // Handle identical references or primitive equality
    if (a === b) return true;

    // // Handle null/undefined mismatch
    if (a == null || b == null) return false;

    // // Handle type mismatch
    if (typeof a !== typeof b) return false;

    // // ✅ Detect File objects (image uploads etc.)
    if (a instanceof File && b instanceof File) {
      return a.name === b.name && a.size === b.size && a.type === b.type;
    }

    // ✅ Detect image URLs (string paths)
    // Handles cases like replacing "image1.jpg" → "image2.jpg"

    if (typeof a === "string" && typeof b === "string") {
      const isImageUrl =
        /\.(jpg|jpeg|png|gif|webp|avif|bmp|svg)$/i.test(a) ||
        /\.(jpg|jpeg|png|gif|webp|avif|bmp|svg)$/i.test(b);

      if (isImageUrl) return a === b;
    }

    // ✅ Arrays
    if (Array.isArray(a)) {
      if (!Array.isArray(b) || a.length !== b.length) return false;
      return a.every((val, i) => deepEqual(val, b[i]));
    }

    // ✅ Objects
    if (typeof a === "object" && typeof b === "object") {
      const keysA = Object.keys(a);
      const keysB = Object.keys(b);
      if (keysA.length !== keysB.length) return false;

      return keysA.every((key) => deepEqual(a[key], b[key]));
    }

    return false;
  }

  const objectListFormikstate = fromGlobal
    ? {
        objectListFormik: objectListFormik,
        fromGlobal: true,
      }
    : fromPin
    ? {
        objectListFormik: objectListFormik,
        fromPin: true,
      }
    : fromCategory
    ? {
        objectListFormik: objectListFormik,
        fromUsedObject: true,
        fromCategory: true,
      }
    : fromMaterial
    ? {
        objectListFormik: objectListFormik,
        fromUsedObject: true,
        fromMaterial: true,
      }
    : fromLocation
    ? {
        objectListFormik: objectListFormik,
        fromLocation: true,
      }
    : {
        objectListFormik: objectListFormik,
      };

  const nextObjectSubmitHandler = async (type) => {
    setIsAutoSave(false);
    await clearAutoSavedFromIndexedDB("conservation");
    if (type === "next") {
      setOverRideMove({
        next: true,
      });
      setNextAndPreviousLoad({
        next: true,
      });
    } else {
      setOverRideMove({
        previous: true,
      });
      setNextAndPreviousLoad({
        previous: true,
      });
    }
    iSubmittedRef.current = true;
    isDetailFetchRef.current = true;

    const hasChanged = !deepEqual(formik.values, initialFormState);

    if (hasChanged) {
      // formik.validateForm().then((errors) => {
      // if (Object.keys(errors).length > 0) {
      //     // Display validation errors
      //     formik.setTouched(
      //         Object.keys(errors).reduce((acc, key) => {
      //             acc[key] = true;
      //             return acc;
      //         }, {})
      //     );
      // } else
      // {
      // Proceed if no validation errors
      const updatedValues = { ...formik.values };
      if (id) {
        updatedValues.id = id;
      }
      if (!updatedValues.stability) {
        delete updatedValues.stability;
      }

      updatedValues.conservation_is_draft = true;

      const payload = {
        ...updatedValues,
        investigation_details: filterInvestigationDetails(
          updatedValues?.investigation_details
        ),
        graphical_represenatation: filterGraphicalRepresentation(
          updatedValues?.graphical_represenatation
        ),
        stratigraphic_assessment: processStratigraphic(
          updatedValues?.stratigraphic_assessment
        ),
        proposed_treatment: processProposedTreatment(
          updatedValues?.proposed_treatment
        ),
        session: sessionIdRef.current,
        // you can add other reversals like graphical_represenatation if needed
      };
      const currentStatus = updatedValues?.object_details?.conservation_status;

      let nextStatus = currentStatus;

      // 🚫 once in conservation → locked forever
      if (currentStatus === "in_conservation") {
        nextStatus = "in_conservation";
      }

      // to_do → in_conditional_assessment
      else if (currentStatus === "to_do") {
        if (hasOtherFieldValue(updatedValues)) {
          nextStatus = "in_conservation";
        } else if (
          updatedValues?.remarks &&
          (updatedValues?.stability || updatedValues?.is_emergency)
        ) {
          nextStatus = "in_conditional_assessment";
        }
      }

      // in_conditional_assessment → in_conservation
      else if (
        currentStatus === "in_conditional_assessment" &&
        hasOtherFieldValue(updatedValues)
      ) {
        nextStatus = "in_conservation";
      }

      setSavedNextConsercationDataOverRide(payload);

      if (online) {
        if (
          updatedValues?.stability ||
          updatedValues?.is_emergency ||
          updatedValues?.remarks
          // &&
          // updatedValues?.remarks
          // updatedValues?.stabilization_guidelines &&
          // updatedValues?.object_handling_guidelines
        ) {
          objectConservationCreation(payload)((response) => {
            if (response?.status) {
              setOverRideMove({
                next: false,
                previous: true,
              });
              setSavedNextConsercationDataOverRide();
              iSubmittedRef.current = true;
              sendSessionClose(
                "conservation",
                sessionIdRef?.current,
                id,
                isChangedRef.current,
                userData?.museum
              );
              if (formik?.values?.assignValue) {
                assignUser(formik?.values?.assignValue)((response) => {
                  if (response?.status) {
                    isDetailFetchRef.current = false;

                    objectConservationStatus({
                      id,
                      conservation_status: nextStatus,
                    })((response) => {
                      if (response?.status) {
                        // success
                      }
                    });
                    if (nextStatus !== currentStatus) {
                      objectConservationStatus({
                        id,
                        conservation_status: nextStatus,
                      })((response) => {
                        if (response?.status) {
                          isDetailFetchRef.current = false;
                          if (type === "next") {
                            setNextAndPreviousLoad({
                              next: false,
                            });
                          } else {
                            setNextAndPreviousLoad({
                              previous: false,
                            });
                          }
                          navigate(
                            `/${
                              userData.museum_name
                                ? userData?.museum_name?.split(" ").join("_")
                                : "Nefos"
                            }/${ADD_CONSERVATION}/${
                              type === "next" ? nextId : previousId
                            }`,
                            {
                              state: objectListFormikstate,
                            }
                          );
                          setId(type === "next" ? nextId : previousId);

                          setUpdate(!update);
                        } else {
                          isDetailFetchRef.current = false;
                        }
                      });
                    }
                  } else {
                    isDetailFetchRef.current = false;
                    if (type === "next") {
                      setNextAndPreviousLoad({
                        next: false,
                      });
                    } else {
                      setNextAndPreviousLoad({
                        previous: false,
                      });
                    }
                  }
                });
              } else {
                objectConservationStatus({
                  id,
                  conservation_status: nextStatus,
                })((response) => {
                  if (response?.status) {
                    isDetailFetchRef.current = false;
                    if (type === "next") {
                      setNextAndPreviousLoad({
                        next: false,
                      });
                    } else {
                      setNextAndPreviousLoad({
                        previous: false,
                      });
                    }
                    navigate(
                      `/${
                        userData.museum_name
                          ? userData?.museum_name?.split(" ").join("_")
                          : "Nefos"
                      }/${ADD_CONSERVATION}/${
                        type === "next" ? nextId : previousId
                      }`,
                      {
                        state: objectListFormikstate,
                      }
                    );
                    setId(type === "next" ? nextId : previousId);
                    setUpdate(!update);
                  } else {
                    isDetailFetchRef.current = false;
                    if (type === "next") {
                      setNextAndPreviousLoad({
                        next: false,
                      });
                    } else {
                      setNextAndPreviousLoad({
                        previous: false,
                      });
                    }
                  }
                });
              }
            } else {
              if (response?.status_code === 400 && response?.conflict) {
                setIsOverRide(true);
              }
              if (!response?.conflict) {
                toast.error(response?.message, {
                  style: {
                    maxWidth: "500px",
                    whiteSpace: "pre-wrap", // allows multiline text
                    wordBreak: "break-word", // long words wrap
                    height: "auto",
                    padding: "12px 16px",
                  },
                });
              }
              iSubmittedRef.current = false;
              if (type === "next") {
                setNextAndPreviousLoad({
                  next: false,
                });
              } else {
                setNextAndPreviousLoad({
                  previous: false,
                });
              }
            }
          });
        } else {
          objectConservationStatus({
            id,
            conservation_status: nextStatus,
          })((response) => {
            if (response?.status) {
              isDetailFetchRef.current = false;
              if (type === "next") {
                setNextAndPreviousLoad({
                  next: false,
                });
              } else {
                setNextAndPreviousLoad({
                  previous: false,
                });
              }
              navigate(
                `/${
                  userData.museum_name
                    ? userData?.museum_name?.split(" ").join("_")
                    : "Nefos"
                }/${ADD_CONSERVATION}/${type === "next" ? nextId : previousId}`,
                {
                  state: objectListFormikstate,
                }
              );
              setId(type === "next" ? nextId : previousId);
              setUpdate(!update);
            } else {
              isDetailFetchRef.current = false;
              if (type === "next") {
                setNextAndPreviousLoad({
                  next: false,
                });
              } else {
                setNextAndPreviousLoad({
                  previous: false,
                });
              }

              toast.error(response?.data?.message);
            }
          });
        }
      } else {
        addItemToDB(updatedValues, "conservation")
          .then(() => {
            toast.success(
              id
                ? "Object updated successfully!"
                : "Object created successfully!"
            );
            formik.resetForm();
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${ADD_CONSERVATION}/${type === "next" ? nextId : previousId}`,
              {
                state: objectListFormikstate,
              }
            );
            setId(type === "next" ? nextId : previousId);
          })
          .catch((error) => {
            console.error("Failed to add item to IndexedDB:", error);
            toast.error("Failed to save data locally.");
          });
      }
    } else {
      isDetailFetchRef.current = false;
      if (type === "next") {
        setNextAndPreviousLoad({
          next: false,
        });
      } else {
        setNextAndPreviousLoad({
          previous: false,
        });
      }

      sendSessionClose(
        "conservation",
        sessionIdRef?.current,
        id,
        isChangedRef.current,
        userData?.museum
      );
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${ADD_CONSERVATION}/${type === "next" ? nextId : previousId}`,
        {
          state: objectListFormikstate,
        }
      );
      setId(type === "next" ? nextId : previousId);
      // setUpdate(!update);
    }
  };

  useEffect(() => {
    if (online) {
      const syncDataWithServer = async () => {
        const pendingRequests = await getPendingRequests("conservation");

        if (pendingRequests?.length > 0) {
          debugger;
          pendingRequests?.map((li) =>
            objectConservationCreation(li)((response) => {
              if (response?.status) {
                iSubmittedRef.current = true;
                sendSessionClose(
                  "conservation",
                  sessionIdRef?.current,
                  id,
                  isChangedRef.current,
                  userData?.museum
                );
                toast.success("Object succesfully uploaded!");
              } else {
                iSubmittedRef.current = false;
                if (response?.status_code === 400 && response?.conflict) {
                  setIsOverRide(true);
                }
              }
            })
          );
        }

        await clearPendingRequests("conservation");
      };

      syncDataWithServer();
    }
  }, []);

  useEffect(() => {
    const handleMouseMove = (event) => {
      const mouseX = event.clientX;
      const inRightSide = mouseX >= window.innerWidth * 0.8;

      setIsVisible(inRightSide);
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const newImage = objectData?.object_images?.map((li) => ({
    original: li?.images,
    thumbnail: li?.thumbnail,
  }));

  const handleClose = () => {
    setShowImage(false);
  };

  let typingTimer;
  const actionLoadOption = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);

      typingTimer = setTimeout(() => {
        if (inputValue.length >= 1) {
          listTreatmentDropdown({
            page: 1,
            museum_id: userData.museum,
            search: inputValue,
          })((response) => {
            if (response?.status) {
              const standardIds = defaultProcedure?.map(
                (value) => value.action
              );
              const updatedActionData = response?.data?.map((actionValue) => ({
                ...actionValue,
                is_standard: standardIds
                  .map(String)
                  .includes(String(actionValue.value)),
              }));
              setAction(updatedActionData);
              resolve(updatedActionData);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  let typingTimerDegradation;
  const degradationLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerDegradation);
      typingTimerDegradation = setTimeout(() => {
        if (inputValue?.length >= 1) {
          listDegradationDropdown({
            page: 1,
            object_id: id,
            search: inputValue,
          })((response) => {
            if (response?.status) {
              setDegradation(response?.data);
              resolve(response?.data);
            }
          });
        }
      }, 300);
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      const el = stabilityCurrentRef.current;
      if (el) {
        const elTop = el.getBoundingClientRect().top + window.pageYOffset;
        const offset = window.innerHeight / 2 - 250; // 100px above center
        window.scrollTo({
          top: elTop - offset,
          behavior: "smooth",
        });
      }
    }, 100);

    return () => clearTimeout(timeout);
  }, [loading]);
  const enableValues = formik?.values;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (stratRef.current && !stratRef.current.contains(event.target)) {
        // Update all `doubleClickActive` to false
        setStratState(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [stratRef]);

  useEffect(() => {
    if (stratState) {
      setIsAutoSave(true);
      const newStrat = formik?.values?.stratigraphic_assessment.map((li) => ({
        ...li,
        doubleClickActive: false,
      }));

      formik?.setValues({
        ...formik?.values,
        stratigraphic_assessment: newStrat,
      });

      setStratState(false);
    }
  }, [stratState]);

  useEffect(() => {
    if (fromNotification) {
      setIsOpen(true);
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [fromNotification]);

  useEffect(() => {
    if (
      formik?.values?.object_details?.conservation_status ===
      "conservation_complete"
    ) {
      if (initialFormState) {
        setHasFormChanged(initialFormState !== formik.values);
      }
    } else {
      setHasFormChanged(true);
    }
  }, [formik.values, initialFormState]);

  useEffect(() => {
    listDegradationDropdown({ page: 1, object_id: id })((response) => {
      if (response?.status) {
        setDegradation(response?.data);
        setDefaultDeagradation(response?.data);
      }
    });
  }, []);

  const customactionComponent = {
    Option: (props) => (
      <div
        {...props.innerRef}
        {...props.innerProps}
        style={{
          backgroundColor: props.isFocused ? "#eee" : "transparent",
          padding: 10,
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p>{props?.data?.label}</p>
        {props?.data?.is_standard && (
          <MdOutlineVerifiedUser fontSize={"25px"} color="#ffcc00" />
        )}
      </div>
    ),
  };

  const customComponents = {
    Option: (props) => (
      <div
        {...props.innerRef}
        {...props.innerProps}
        style={{
          backgroundColor: props.isFocused ? "#eee" : "transparent",
          padding: 10,
          cursor: "pointer",
        }}
      >
        {`${props.data.label} (${props?.data?.assessment_name})`}
      </div>
    ),
  };

  // console.log(degradation, "degradation");

  const conditionDegradationBlur = (
    e,
    assesmentIndex,
    detailIndex,
    assessmentValue
  ) => {
    setIsAutoSave(true);
    const assessmentList = [...formik?.values?.stratigraphic_assessment];
    const assessmentId =
      assessmentList[assesmentIndex].assessment_details[detailIndex]
        .degradationUid;
    const assessmentDegradationId =
      assessmentList[assesmentIndex].assessment_details[detailIndex].id;
    const degradationInput = e?.target?.value;

    if (assessmentId || assessmentDegradationId) {
      if (degradationInput === "") {
        setDegradation(degradation);
      } else {
        if (assessmentId) {
          const existingIndex = degradation?.findIndex(
            (item) => item.temp_id === assessmentId
          );
          const updatedDegradation = [...degradation];
          updatedDegradation[existingIndex].value = degradationInput;
          updatedDegradation[existingIndex].label = degradationInput;
          setDegradation(updatedDegradation);
          selectedDegradation?.temp_id === assessmentId
            ? setSelectedDegradation({
                ...selectedDegradation,
                label: `${degradationInput} (${assessmentList[assesmentIndex]?.assessment_name})`,
              })
            : setSelectedDegradation(selectedDegradation);
        } else {
          const updatedDegradationId = [...degradation];

          selectedDegradation?.value === assessmentDegradationId
            ? setSelectedDegradation({
                ...selectedDegradation,
                label: `${degradationInput} (${assessmentList[assesmentIndex]?.assessment_name})`,
              })
            : setSelectedDegradation(selectedDegradation);
          const existinngIdIndexofdegradation = degradation?.findIndex(
            (itemId) => {
              return itemId?.value === assessmentDegradationId; // Ensure the function returns a value
            }
          );

          updatedDegradationId[existinngIdIndexofdegradation].label =
            degradationInput;
          setDegradation(updatedDegradationId);
        }
      }
    } else {
      const myUniqueId = uuidv4();
      const trimmedId = myUniqueId.slice(0, 8);
      const newDegradation = {
        assesmentIndex: assesmentIndex,
        detailIndex: detailIndex,
        value: degradationInput,
        label: degradationInput,
        assessment_name: assessmentValue?.assessment_name,
        temp_id: trimmedId,
      };
      assessmentList[assesmentIndex].assessment_details[
        detailIndex
      ].degradationUid = trimmedId;
      formik?.setValues({
        ...formik?.values,
        stratigraphic_assessment: assessmentList,
      });
      setDegradation([...degradation, newDegradation]);
    }
  };

  const conditionDegradationChangeHandler = (
    e,
    assesmentIndex,
    detailIndex,
    assessmentValue
  ) => {
    setIsAutoSave(true);
    const degradationValue = e?.target?.value;
    const assessmentList = [...formik?.values?.stratigraphic_assessment];
    const assessmentId =
      assessmentList[assesmentIndex].assessment_details[detailIndex]
        .degradationUid;
    const assessmentDegradationId =
      assessmentList[assesmentIndex].assessment_details[detailIndex].id;

    if (assessmentId) {
      const proposedList = [...formik?.values?.proposed_treatment];
      const newProposeListTemp = proposedList?.map((tempItem) => {
        if (assessmentId === tempItem?.selectedDegradation?.temp_id) {
          return {
            ...tempItem,
            selectedDegradation: {
              ...tempItem?.selectedDegradation,
              label: `${degradationValue} (${assessmentList[assesmentIndex].assessment_name})`,
            },
          };
        }
        return tempItem;
      });
      assessmentList[assesmentIndex].assessment_details[
        detailIndex
      ].degradation = degradationValue;
      formik?.setValues({
        ...formik?.values,
        proposed_treatment: newProposeListTemp,
        stratigraphic_assessment: assessmentList,
      });
      return;
    } else if (assessmentDegradationId) {
      const proposedList = [...formik?.values?.proposed_treatment];
      const newProposeList = proposedList?.map((itemMatch) => {
        if (itemMatch?.degradation === assessmentDegradationId) {
          if (itemMatch?.selectedDegradation) {
            return {
              ...itemMatch,
              selectedDegradation: {
                ...itemMatch.selectedDegradation,
                label: `${degradationValue} (${assessmentList[assesmentIndex].assessment_name})`,
              },
            };
          } else {
            return {
              ...itemMatch,
              degradation_name: degradationValue,
              assessment_name: assessmentList[assesmentIndex].assessment_name,
            };
          }
        }
        return itemMatch;
      });

      assessmentList[assesmentIndex].assessment_details[
        detailIndex
      ].degradation = degradationValue;
      formik?.setValues({
        ...formik?.values,
        proposed_treatment: newProposeList,
        stratigraphic_assessment: assessmentList,
      });
      return;
    }
    assessmentList[assesmentIndex].assessment_details[detailIndex].degradation =
      degradationValue;
    formik?.setValues({
      ...formik?.values,
      stratigraphic_assessment: assessmentList,
    });
  };

  const userChangeHandler = (value) => {
    setIsAutoSave(true);
    setSelectedUser(value);
    formik?.setValues({
      ...formik.values,
      assignValue: {
        id: id,
        object_assigned: value?.value,
      },
    });
  };

  const pinChangeHandler = (e) => {
    formik?.setValues({
      ...formik?.values,
      is_pinned: formik?.values?.is_pinned ? false : true,
    });

    if (!formik?.values?.is_pinned) {
      addPinObject({ museum: userData?.museum, museum_object: id })(
        (pinnedResponse) => {
          if (pinnedResponse) {
          }
        }
      );
    } else {
      deletePinObject({ id: [id] })((response) => {
        if (response?.status) {
        }
      });
    }
  };

  let typingTimerUser;
  const userLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerUser);
      typingTimerUser = setTimeout(() => {
        if (inputValue.length >= 1) {
          listUserDropdown({
            page: 1,
            museum_id: userData.museum,
            search: inputValue,
          })((response) => {
            if (response?.status) {
              setUser(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  useEffect(() => {
    listUserDropdown({ page: 1, museum_id: userData.museum })((response) => {
      if (response?.status) {
        setUser(response?.data);
        setDefaultUser(response?.data);
      }
    });
  }, []);

  useEffect(() => {
    if (isAutosave) {
      const savedFormik = formik?.values;
      if (id) savedFormik.id = id;
      autoSaveToIndexedDB("conservation", savedFormik);
    }
  }, [formik]);

  useEffect(() => {
    if (actionNewValue === "") {
      setAction(defaultAction);
    }
  }, [actionNewValue, action]);

  useEffect(() => {
    if (newValue === "") {
      setUser(defaultUser);
    }
  }, [newValue, user]);

  // useEffect(() => {
  //     const fixedEl = titleRowRef.current;
  //     const containerEl = containerRowRef.current;

  //     const updateFixedHeader = () => {
  //         if (fixedEl && containerEl) {

  //             const { left, width } = containerEl.getBoundingClientRect();
  //             console.log(width, "width");

  //             fixedEl.style.left = `${left}px`;
  //             fixedEl.style.width = `${width}px`;

  //         }Page number
  //     };

  //     updateFixedHeader()
  //     window.addEventListener('resize', updateFixedHeader);

  //     return () => {
  //         window.removeEventListener('resize', updateFixedHeader);
  //     };
  // }, [id, user, isOpen, loading]);

  useEffect(() => {
    if (fromList) {
      setId(objectId);
    }
  }, [objectId]);

  useEffect(() => {
    if (!fromList) {
      const values = {
        museum: userData?.museum,
        screen: "Conservation",
      };
      if (userUsedLastScreen !== "Conservation") {
        usedLastScreen(values)((response) => {
          localStorage.setItem(
            "user_info",
            JSON.stringify({ ...userData, last_used_screen: "Conservation" })
          );
        });
      }
    }
  }, []);

  const Notificationpop = ({
    isVisible,
    toggleDrawer,
    toggleDrawerhistory,
  }) => {
    return createPortal(
      <div
        className="notification"
        style={{
          zIndex: "999",
          display: isVisible ? "block" : "none",
          opacity: isVisible ? 1 : 0,
          visibility: isVisible ? "visible" : "hidden",
        }}
      >
        <Tooltip title="Discussions" placement="left">
          <div className="cmt-icon-query" onClick={toggleDrawer}>
            <TbMessageCircleCheck size={21} />
          </div>
        </Tooltip>
        <Tooltip title="History" placement="left">
          <div className="cmt-icon-history" onClick={toggleDrawerhistory}>
            <RiHistoryLine size={20} />
          </div>
        </Tooltip>
      </div>,
      document.body
    );
  };

  const overRideConfirmHandler = () => {
    iSubmittedRef.current = true;
    setIsOverRide(false);
    setButtonloader({ save: true });
    setLoading(true);

    const updatedValues = {
      ...savedNextConservationDataOverRide,
      is_override: true,
    };

    // Determine conservation status
    const hasActiveTreatment = updatedValues?.proposed_treatment?.some(
      (treatment) =>
        ["Started", "In progress", "Done"].includes(treatment.status)
    );

    const currentStatus = updatedValues?.object_details?.conservation_status;

    let nextStatus = currentStatus;

    // 🚫 once in conservation → locked forever
    if (currentStatus === "in_conservation") {
      nextStatus = "in_conservation";
    }

    // to_do → in_conditional_assessment
    else if (
      currentStatus === "to_do" &&
      updatedValues?.remarks &&
      (updatedValues?.stability || updatedValues?.is_emergency)
    ) {
      nextStatus = "in_conditional_assessment";
    }

    // in_conditional_assessment → in_conservation
    else if (
      currentStatus === "in_conditional_assessment" &&
      hasOtherFieldValue(updatedValues)
    ) {
      nextStatus = "in_conservation";
    }

    // API call: Create or update conservation
    objectConservationCreation(updatedValues)((response) => {
      const isSuccess = response?.status;

      if (!isSuccess) {
        // Reset override state on failure
        setOverRideMove({ next: false, previous: false });
        setSavedNextConsercationDataOverRide();
        setButtonloader({ save: false });
        setLoading(false);
        return;
      }

      // ✅ Success flow
      setSavedNextConsercationDataOverRide();
      iSubmittedRef.current = true;
      setButtonloader({ save: false });

      const basePath = userData.museum_name?.split(" ").join("_") || "Nefos";

      // Navigation logic

      if (fromList) {
        onCloseObject();
      } else if (overRideMove?.next) {
        navigate(`/${basePath}/${ADD_CONSERVATION}/${nextId}`, {
          state: objectListFormikstate,
        });
        setId(nextId);
        isDetailFetchRef.current = false;
        setUpdate(!update);
        setOverRideMove({ next: false, previous: false });
      } else if (overRideMove?.previous) {
        navigate(`/${basePath}/${ADD_CONSERVATION}/${previousId}`, {
          state: objectListFormikstate,
        });
        setId(previousId);
        isDetailFetchRef.current = false;
        setUpdate(!update);
        setOverRideMove({ next: false, previous: false });
      } else {
        setUpdate(!update);
        setOverRideMove({ next: false, previous: false });
        navigate(`/${basePath}/${CONSERVATION_KANBAN}`);
      }

      // Update conservation status if applicable
      const shouldUpdateStatus =
        (updatedValues?.stability || updatedValues?.is_emergency) &&
        updatedValues?.remarks;

      if (shouldUpdateStatus) {
        if (nextStatus !== currentStatus) {
          objectConservationStatus({
            id,
            conservation_status: nextStatus,
          })((response) => {
            if (response?.status) {
              // success
            }
          });
        }
      }

      // Assign user if available
      if (formik?.values?.assignValue) {
        assignUser(formik.values.assignValue)((res) => {
          if (!res?.status) console.warn("Failed to assign user");
        });
      }
    });
  };

  const overRideCancel = (isClosed) => {
    setOverRideMove({
      next: false,
      previous: false,
    });
    setSavedNextConsercationDataOverRide();
    sessionRef.current = false;
    isDetailFetchRef.current = false;
    formik?.setValues(initialFormState);
    setUpdate(!update);
    setIsOverRide(false);
    cancelSession({ id: sessionIdRef.current })((cancelResponse) => {
      if (cancelResponse?.status) {
        if (isClosed) {
          if (fromObjectTable) {
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${LIST_CONSERVATION}`
            );
          } else {
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${CONSERVATION_KANBAN}`
            );
          }
        } else {
          setUpdate(!update);
        }
      }
    });
  };

  useEffect(() => {
    // Compare current form values with initialValues

    if (id) {
      if (isDetaillRef.current && isAutosave) {
        const hasChangedDetail = !deepEqual(formik?.values, initialFormState);
        if (hasChangedDetail) {
          isChangedRef.current = true;
          localStorage.setItem("conservationchanges", true);
        } else {
          isChangedRef.current = false;
        }
      }
    }
  }, [formik.values]);

  useEffect(() => {
    const markRefresh = () => {
      if (!iSubmittedRef.current) {
        sessionStorage.setItem("justRefreshed", "true");
      }
    };
    window.addEventListener("beforeunload", markRefresh);
    return () => {
      window.removeEventListener("beforeunload", markRefresh);
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (!iSubmittedRef.current && !isAutoSaveRef?.current) {
        debugger;
        sendSessionClose(
          "digital",
          sessionIdRef?.current,
          id,
          isChangedRef.current,
          userData?.museum,
          "isClosing"
        );
      }
    };
    window.addEventListener("unload", handleBeforeUnload);
    return () => window.removeEventListener("unload", handleBeforeUnload);
  }, []);

  useEffect(() => {
    return () => {
      if (!iSubmittedRef.current && !isAutoSaveRef.current) {
        sendSessionClose(
          "digital",
          sessionIdRef?.current,
          id,
          isChangedRef.current,
          userData?.museum,
          "isClosing"
        );
      }
    };
  }, [location.pathname]);

  useEffect(() => {
    isAutoSaveRef.current = isAutosave;
  }, [isAutosave]);

  return (
    <section
      style={{ paddingTop: "60px" }}
      className="dashboard asset-management light-wrapper dark-wrapper"
    >
      {showImageEnlarge?.show && (
        <ImageEnlarge
          imageData={showImageEnlarge}
          setShowReference={setShowEnlargeImage}
        />
      )}
      <div className="add-building-container add-conservation-container">
        {fromList ? (
          <Notificationpop
            isVisible={isVisible}
            toggleDrawer={toggleDrawer}
            toggleDrawerhistory={toggleDrawerhistory}
          />
        ) : (
          <div
            className="notification"
            style={{
              display: isVisible ? "block" : "none",
              opacity: isVisible ? 1 : 0,
              visibility: isVisible ? "visible" : "hidden",
            }}
          >
            <Tooltip
              title="Discussions"
              placement="left"
              sx={{
                backgroundColor: "#E2F1FF ",
              }}
            >
              <div className="cmt-icon-query" onClick={toggleDrawer}>
                <TbMessageCircleCheck size={21} />
              </div>
            </Tooltip>
            <Tooltip title="History" placement="left">
              <div className="cmt-icon-history" onClick={toggleDrawerhistory}>
                <RiHistoryLine size={20} />
              </div>
            </Tooltip>
          </div>
        )}
        <Container ref={containerRowRef}>
          {loading ? (
            <Loader />
          ) : (
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onSubmit={formik.handleSubmit}
            >
              {(buttonloader?.complete ||
                buttonloader.continue ||
                buttonloader?.next ||
                buttonloader?.save) && <div className="overlay-cover" />}

              <div
                onClick={() => setIsOpen(false)}
                ref={titleRowRef}
                className="add-category-title-row"
                style={{
                  flexDirection: "column",
                  position: "sticky",
                  zIndex: "2",
                  backgroundColor: "white",
                  top: fromList ? "0px" : "61px",
                  paddingTop: "20px",
                  boxShadow: "rgba(0, 0, 0, 0.45) 0px 25px 20px -34px",
                }}
              >
                <div
                  className=" title-row-content"
                  style={{ justifyContent: "space-between" }}
                >
                  <div style={{ display: "flex", gap: "9px" }}>
                    <div className="title-icon " onClick={handleBack}>
                      <GoArrowLeft />
                    </div>
                    <div className=" titles">
                      <p>Back to Object list</p>
                      <h4>Conservation details</h4>
                    </div>
                  </div>
                  <div
                    className="submit-btn-row next-and-previous-btn-row"
                    style={{ paddingBottom: "0px", paddingTop: "0px" }}
                  >
                    {!fromList && (
                      <Tooltip
                        placement="top-start"
                        title={previousId ? "" : "No previous object"}
                      >
                        <Button
                          type="button"
                          className={
                            nextAndPreviousLoad?.previous
                              ? "submit-btn"
                              : "discard-btn"
                          }
                          // style={{
                          //   backgroundColor: "#20409A",
                          //   cursor: previousId ? "pointer" : "not-allowed",
                          //   pointerEvents: "auto",
                          // }}
                          onClick={() => nextObjectSubmitHandler("previous")}
                          disabled={!previousId}
                          style={{
                            cursor: previousId ? "pointer" : "not-allowed",
                            pointerEvents: "auto",
                            paddingBottom: "6px",
                            paddingTop: "6px",
                          }}
                        >
                          {nextAndPreviousLoad?.previous ? (
                            <SimpleBackdrop />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "7px",
                              }}
                            >
                              <GrLinkPrevious style={{ fontSize: "18px" }} />
                              <p> Previous object</p>
                            </div>
                          )}
                        </Button>
                      </Tooltip>
                    )}
                    {!fromList && (
                      <Tooltip
                        placement="top-end"
                        title={nextId ? "" : "No next object"}
                      >
                        <Button
                          // style={{
                          //   backgroundColor: "#20409A",
                          //   cursor: nextId ? "pointer" : "not-allowed",
                          //   pointerEvents: "auto",
                          // }}
                          type="button"
                          className={
                            nextAndPreviousLoad?.next
                              ? "submit-btn"
                              : "discard-btn"
                          }
                          style={{
                            cursor: nextId ? "pointer" : "not-allowed",
                            pointerEvents: "auto",
                            paddingBottom: "6px",
                            paddingTop: "6px",
                          }}
                          disabled={!nextId}
                          onClick={() => nextObjectSubmitHandler("next")}
                        >
                          {nextAndPreviousLoad?.next ? (
                            <SimpleBackdrop />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "7px",
                              }}
                            >
                              <p> Next object</p>
                              <GrLinkNext style={{ fontSize: "18px" }} />
                            </div>
                          )}
                        </Button>
                      </Tooltip>
                    )}
                  </div>
                </div>
                <Row className="object-assign-container conservation-assign-container">
                  <Col lg={5} className="left-input-assign">
                    <div className="left-input-field">
                      <Form.Label className="leftinput-label">
                        Object name
                      </Form.Label>

                      <h5
                        style={{ fontWeight: "bold", wordBreak: "break-word" }}
                      >
                        {objectData?.object_name}
                      </h5>
                    </div>
                  </Col>
                  <Col className="right-input-assign" lg={4}>
                    <Form.Group className="right-input-field">
                      <Form.Label className="rightinput-label">
                        Assign user
                      </Form.Label>

                      <AsyncSelect
                        loadOptions={userLoadOptionHandler}
                        defaultOptions={user}
                        value={selectedUser}
                        type="text"
                        placeholder="Select"
                        className="assign-user-async"
                        onChange={userChangeHandler}
                        onInputChange={(newValue, { action }) => {
                          setNewValue(newValue);
                          if (action === "input-change" && newValue === "") {
                            setUser(defaultUser); // Reset to default options
                          }
                        }}
                      />
                    </Form.Group>
                    <div className="object-pin-container">
                      <div style={{ display: "flex", gap: "9px" }}>
                        <Tooltip
                          title={
                            formik?.values?.is_pinned
                              ? "Unpin object"
                              : "Pin object"
                          }
                        >
                          <div
                            className={
                              formik?.values?.is_pinned
                                ? "objectpin-container"
                                : "object-unpin-container"
                            }
                            onClick={pinChangeHandler}
                          >
                            <LuPin />
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* {/* <Modal show >
                                <Modal.Header closeButton></Modal.Header>
                                <Modal.Body> */}

              {/* </Modal.Body>
                            </Modal> */}

              <div
                onClick={() => {
                  setIsOpenhistory(false);
                  setIsOpen(false);
                }}
                className="add-object-field-box"
              >
                {/* <ReactImageGallery
                                    // items={moreImages}
                                    showFullscreenButton
                                    showIndex
                                /> */}
                <Row className="primary-field-row">
                  <div className="add-object">
                    <div className="feature-full-div">
                      {/* <Row style={{ width: "100%" }}> */}
                      <div className="col-lg-7 feature-left-cons ">
                        <ul className="field-ul">
                          <li className="field-li row">
                            <div className="col-md-3">Primary category</div>
                            <div
                              className="col-md-7"
                              style={{
                                display: "flex",
                                gap: "11px",
                                alignItems: "center",
                              }}
                            >
                              {objectData?.prime_category_name}
                              {objectData?.prime_category_code && (
                                <p style={{ color: "gray" }}>
                                  {`(${objectData?.prime_category_code})`}
                                </p>
                              )}
                              {objectData?.prime_key_category === "True" && (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    style={{ height: "18px" }}
                                    src={star}
                                    alt="key-category"
                                  />
                                </div>
                              )}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-3">Subcategory</div>
                            <div
                              className="col-md-7"
                              style={{
                                display: "flex",
                                gap: "11px",
                                alignItems: "center",
                              }}
                            >
                              {objectData?.category_name}
                              {objectData?.category_code && (
                                <p style={{ color: "gray" }}>
                                  {` (${objectData?.category_code}) `}
                                </p>
                              )}
                              {objectData?.key_category === "True" && (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    style={{ height: "18px" }}
                                    src={star}
                                    alt="key-category"
                                  />
                                </div>
                              )}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-3">Object label</div>
                            <div
                              className="col-md-7"
                              style={{
                                display: "flex",
                                gap: "11px",
                                alignItems: "center",
                              }}
                            >
                              {objectData?.object_label}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div
                              className="col-md-3"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Number of parts
                            </div>
                            <div className="col-md-7">
                              <p>{objectData?.number_of_parts}</p>
                            </div>
                          </li>
                          <li className="field-li row">
                            <div
                              className="col-md-3"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Number of missing pieces
                            </div>
                            <div className="col-md-7">
                              <p>{objectData?.number_of_missing_pieces}</p>
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-3">Materials</div>
                            <div
                              className="col-md-7"
                              style={{
                                display: "flex",
                                gap: "5px",
                                flexWrap: "wrap",
                              }}
                            >
                              <div
                                className="material_tags"
                                style={{ flexWrap: "wrap" }}
                              >
                                {objectData?.material?.map((li) => (
                                  <p className="p_tag">{li?.material_name} </p>
                                ))}
                              </div>
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-3">Dimension (cm)</div>
                            <div
                              style={{
                                display: "flex",
                                gap: "20px",
                                flexWrap: "wrap",
                              }}
                              className="col-md-7"
                            >
                              <div style={{ display: "flex" }}>
                                Height-<p>{objectData?.height}</p>
                              </div>
                              <div style={{ display: "flex" }}>
                                Width-<p>{objectData?.width}</p>
                              </div>
                              <div style={{ display: "flex" }}>
                                Depth-<p>{objectData?.depth}</p>
                              </div>
                              {objectData?.other_dimensions?.map((li) => (
                                <div style={{ display: "flex" }}>
                                  {`${li?.dimension_name}-`}
                                  <p>{li?.dimension_value}</p>
                                </div>
                              ))}
                            </div>
                          </li>
                          {objectData?.descriptors?.length > 0 && (
                            <li className="field-li row">
                              <div className="col-md-3">
                                <p>Category descriptors</p>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "20px",
                                  flexWrap: "wrap",
                                }}
                                className="col-md-7"
                              >
                                {objectData?.descriptors?.map((li) => {
                                  let multiDEscr = [];
                                  if (
                                    li?.attribute_type === "Multiple dropdown"
                                  ) {
                                    multiDEscr = li?.description
                                      ? JSON.parse(li?.description)
                                      : [];
                                  }
                                  return (
                                    <div style={{ display: "flex" }}>{`${
                                      li?.attribute_name
                                        ? li?.attribute_name
                                            .charAt(0)
                                            .toUpperCase() +
                                          li?.attribute_name.slice(1)
                                        : ""
                                    }-${
                                      li?.attribute_type === "Multiple dropdown"
                                        ? multiDEscr?.map((li) => ` ${li}`)
                                        : li?.description
                                    } `}</div>
                                  );
                                })}
                              </div>
                            </li>
                          )}
                          <li className="field-li row">
                            <div className="col-md-3">Dateable time period</div>
                            <div className="dateable-time-div col-md-6">
                              <div className="dateable-input-select-div">
                                <p>{objectData?.period}</p>
                              </div>
                              <div className="dateable-input-select-div">
                                <p>{objectData?.period_start_date}</p>
                              </div>{" "}
                              -
                              <div className="dateable-input-select-div">
                                <p>{objectData?.period_end_date}</p>
                              </div>
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-3">
                              Preliminary assessment{" "}
                            </div>
                            <div className="col-md-7">
                              {objectData?.preliminary_condition_assessment}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-3">Original location</div>
                            <div className="col-md-7">
                              {`${
                                (objectData?.original_location_room &&
                                  objectData?.original_location_room
                                    ?.room_number) ||
                                (objectData?.original_location_storage_system &&
                                  objectData?.original_location_storage_system
                                    ?.storage_system_name) ||
                                (objectData?.original_location_storage_unit &&
                                  objectData?.original_location_storage_unit
                                    ?.storage_unit)
                              }`}
                              {(objectData?.original_location_room?.code ||
                                objectData?.original_location_storage_system
                                  ?.code ||
                                objectData?.original_location_storage_unit
                                  ?.code) && (
                                <span
                                  style={{
                                    color: "gray",
                                    marginLeft: "9px",
                                    fontSize: "16px",
                                  }}
                                >
                                  (
                                  {objectData?.original_location_room?.code ||
                                    objectData?.original_location_storage_system
                                      ?.code ||
                                    objectData?.original_location_storage_unit
                                      ?.code}
                                  )
                                </span>
                              )}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-3">Transit location</div>
                            <div className="col-md-7">
                              {`${
                                (objectData?.transit_location_room &&
                                  objectData?.transit_location_room
                                    ?.room_number) ||
                                (objectData?.transit_location_storage_system &&
                                  objectData?.transit_location_storage_system
                                    ?.storage_system_name) ||
                                (objectData?.transit_location_storage_unit &&
                                  objectData?.transit_location_storage_unit
                                    ?.storage_unit)
                              }`}
                              {(objectData?.transit_location_room?.code ||
                                objectData?.transit_location_storage_system
                                  ?.code ||
                                objectData?.transit_location_storage_unit) && (
                                <span
                                  style={{
                                    color: "gray",
                                    marginLeft: "9px",
                                    fontSize: "16px",
                                  }}
                                >
                                  {`(${
                                    objectData?.transit_location_room?.code
                                      ? objectData?.transit_location_room?.code
                                      : "" ||
                                        objectData
                                          ?.transit_location_storage_system
                                          ?.code
                                      ? objectData
                                          ?.transit_location_storage_system
                                          ?.code
                                      : "" ||
                                        objectData
                                          ?.transit_location_storage_unit?.code
                                      ? objectData
                                          ?.transit_location_storage_unit?.code
                                      : ""
                                  })`}
                                </span>
                              )}
                            </div>
                          </li>
                        </ul>
                        <div className="modal-image-conserve">
                          <Modal
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              boxShadow: "none", // Remove shadow if present
                            }}
                            className="image-gallery-modal"
                            onHide={handleClose}
                            show={showImage}
                          >
                            <Modal.Header
                              closeButton
                              style={{ border: "none" }}
                            ></Modal.Header>
                            <ReactImageGallery items={newImage} />
                          </Modal>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 feature-right-cons">
                        <div>
                          <div
                            style={{ cursor: "pointer" }}
                            className="img-main-cons"
                          >
                            <div className=" img-cons">
                              <div className="iconic-object">
                                <RiVipCrownFill />
                              </div>

                              <img
                                onClick={() => {
                                  let multiImage = [
                                    {
                                      images: objectData?.reference_image,
                                      thumbnail: objectData?.reference_image,
                                    },
                                    ...(objectData?.object_images || []),
                                  ];

                                  // Remove the last element if its `images` value ends with `.glb`
                                  if (multiImage.length > 0) {
                                    const lastItem =
                                      multiImage[multiImage.length - 1];
                                    if (
                                      typeof lastItem?.images === "string" &&
                                      lastItem.images.includes(".glb")
                                    ) {
                                      multiImage = multiImage.slice(0, -1); // remove last element
                                    }
                                  }

                                  setShowEnlargeImage({
                                    image:
                                      objectData?.object_images?.length > 1
                                        ? multiImage
                                        : objectData?.reference_image,
                                    title: "Reference image",
                                    show: true,
                                    isEdit: false,
                                  });
                                }}
                                height={"330px"}
                                width={"100%"}
                                className=""
                                src={objectData?.reference_image}
                                alt="ref-img"
                                style={{ cursor: "pointer" }}
                              />
                            </div>
                            <div style={{ height: "20%", width: "100%" }}>
                              {/* <p>{objectData?.accession_number}</p> */}
                            </div>
                          </div>
                          <div className="qr-code-main-div-cons">
                            <div className="">
                              <img
                                className=""
                                src={objectData?.object_qr_code}
                                alt="QR code"
                              />
                            </div>
                            <div
                              style={{
                                height: "20%",
                                width: "100%",
                                display: "flex",
                                justifyContent: "end",
                              }}
                            >
                              {/* <p>{objectData?.accession_number}</p> */}
                            </div>
                          </div>
                          <div className="multiple-image-box">
                            {objectData?.object_images
                              ?.filter((li) => {
                                const img = li?.images;
                                return !(
                                  typeof img === "string" &&
                                  img.includes(".glb")
                                );
                              })
                              ?.slice(0, 4)
                              .map((li, indexOfimage) => (
                                <>
                                  <div
                                    className={
                                      objectData?.object_images?.length > 4 &&
                                      indexOfimage === 3
                                        ? "image-box-more"
                                        : "image-box"
                                    }
                                  >
                                    <div>
                                      {
                                        li?.images && (
                                          <img
                                            src={li?.thumbnail || li?.images}
                                            alt="multi-img"
                                          />
                                        )

                                        // <Canvas
                                        //     key={`preview-${indexOfimage}-${li?.images}`}
                                        //     camera={{ position: [0, 0, 1], fov: 50 }}
                                        //     gl={{
                                        //         preserveDrawingBuffer: true,
                                        //         antialias: true,
                                        //         alpha: true,
                                        //         powerPreference: "high-performance"
                                        //     }}
                                        // >
                                        //     <ambientLight intensity={1.2} />
                                        //     <directionalLight position={[5, 5, 5]} intensity={1.5} />
                                        //     <directionalLight position={[-5, 5, -5]} intensity={0.8} />
                                        //     <pointLight position={[0, 10, 0]} intensity={1.5} />
                                        //     <Suspense fallback={null}>
                                        //         <Bounds fit clip observe margin={1.2}>
                                        //             <Model
                                        //                 key={`preview-model-${indexOfimage}`}
                                        //                 imageUrl={li?.images}
                                        //             />
                                        //         </Bounds>
                                        //     </Suspense>
                                        // </Canvas>
                                      }
                                    </div>
                                    {li?.image_position === "glb" && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "0",
                                          right: "0",
                                        }}
                                        className="3d-icon-container"
                                      >
                                        <Md3dRotation />
                                      </div>
                                    )}
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        let multiImage = [
                                          {
                                            images: objectData?.reference_image,
                                            thumbnail:
                                              objectData?.reference_image,
                                          },
                                          ...(objectData?.object_images || []),
                                        ];

                                        // Remove the last element if its `images` value ends with `.glb`
                                        if (multiImage.length > 0) {
                                          const lastItem =
                                            multiImage[multiImage.length - 1];
                                          if (
                                            typeof lastItem?.images ===
                                              "string" &&
                                            lastItem.images.includes(".glb")
                                          ) {
                                            multiImage = multiImage.slice(
                                              0,
                                              -1
                                            ); // remove last element
                                          }
                                        }

                                        setShowEnlargeImage({
                                          image:
                                            objectData?.object_images?.length >
                                            1
                                              ? multiImage
                                              : objectData?.reference_image,
                                          title: "Reference image",
                                          show: true,
                                          isEdit: false,
                                        });
                                      }}
                                      className="plus-icon"
                                    >
                                      <HiOutlinePlus />
                                      <p>
                                        {objectData?.object_images?.length - 4}
                                      </p>
                                    </div>
                                    {objectData?.object_images?.length > 4 &&
                                      indexOfimage === 3 && (
                                        <div>
                                          <div className="image-box-more-overlay"></div>
                                        </div>
                                      )}
                                  </div>
                                </>
                              ))}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              marginTop: "15px",
                            }}
                          >
                            <p>{objectData?.accession_number}</p>
                          </div>
                        </div>
                      </div>
                      {/* </Row> */}
                    </div>
                    <Accordion color="blue">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header
                          style={{
                            borderBottom: "1px solid lightgray",
                            zIndex: 0,
                            position: "relative",
                          }}
                          bsPrefix="object-accordion-header"
                        >
                          <h6
                            style={{ fontWeight: "600", marginLeft: "-20px" }}
                          >
                            Object details
                          </h6>
                        </Accordion.Header>
                        <Accordion.Body style={{ marginLeft: "0px" }}>
                          <div style={{ marginTop: "30px" }}>
                            <ul className="field-ul">
                              <li className="field-li row">
                                <div className="col-md-2">Provenance</div>
                                <div className="col-md-8">
                                  {objectData?.provenance}
                                </div>
                              </li>
                              <li className="field-li row">
                                <div className="col-md-2">
                                  Acquisition method
                                </div>
                                <div className="col-md-8">
                                  {objectData?.acquisition_method}
                                </div>
                              </li>

                              <li className="field-li row ">
                                <div className="col-md-2">Tags</div>
                                <div className="col-md-8">
                                  <div className="tags">
                                    {objectData?.tags?.map((iteam, index) => (
                                      <p key={index} className="p_tag">
                                        {iteam?.tag_name}
                                      </p>
                                    ))}
                                  </div>
                                </div>
                              </li>
                              {/* <li className='field-li row' >
                                                                <div className='col-md-2'>Detailed description</div>
                                                                <div className='col-md-8'>
                                                                    <p>{objectData?.description}</p>
                                                                </div>
                                                            </li> */}
                              <li className="field-li row ">
                                <div className="col-md-2">Related object</div>
                                <div className="col-md-8">
                                  <div className="tags">
                                    {objectData?.related_museum_object?.map(
                                      (iteam, index) => (
                                        <p key={index} className="p_tag">
                                          {iteam?.label}
                                        </p>
                                      )
                                    )}
                                  </div>
                                </div>
                              </li>
                              <li className="field-li row ">
                                <div className="col-md-2">
                                  Function or usage
                                </div>
                                <div className="col-md-8">
                                  <div className="tags">
                                    {objectData?.function_or_usages?.map(
                                      (iteam, index) => (
                                        <p key={index} className="p_tag">
                                          {iteam?.function_or_usage}
                                        </p>
                                      )
                                    )}
                                  </div>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div className="col-md-2">
                                  Inscriptions or markers
                                </div>
                                <div className="col-md-8">
                                  <p>{objectData?.inscription_or_markers}</p>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div className="col-md-2">
                                  {" "}
                                  Additional notes
                                </div>
                                <div className="col-md-8">
                                  <p>{objectData?.additional_notes}</p>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div className="col-md-2">
                                  Historical description
                                </div>
                                <div className="col-md-10">
                                  <p>{objectData?.historical_description}</p>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div className="col-md-2">Technique</div>
                                <div className="col-md-10">
                                  <p>{objectData?.technique}</p>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div className="col-md-2">
                                  Cultural significance
                                </div>
                                <div className="col-md-10">
                                  <p>{objectData?.cultural_significance}</p>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div
                                  className="col-md-2"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  {" "}
                                  References/Bibliography
                                </div>
                                <div className="col-md-10">
                                  <p>{objectData?.references}</p>
                                </div>
                              </li>

                              <li className="field-li row">
                                <div
                                  className="col-md-2"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  Ledger number
                                </div>
                                <div className="col-md-10">
                                  <p>{objectData?.ledger_number}</p>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div
                                  className="col-md-2"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  Ledger image
                                </div>
                                <div className="col-md-10">
                                  {objectData?.ledger_image && (
                                    <div
                                      style={{
                                        height: "100px",
                                        width: "100px",
                                        borderRadius: "10px",
                                        border: "1px solid rgb(238, 238, 238)",
                                        padding: "5px",
                                      }}
                                    >
                                      <img
                                        onClick={() => {
                                          setShowEnlargeImage({
                                            show: true,
                                            image: objectData?.ledger_image,
                                            isEdit: false,
                                            title: "Ledger image",
                                          });
                                        }}
                                        src={objectData?.ledger_image}
                                        style={{
                                          height: "100%",
                                          width: "100%",
                                          objectFit: "contain",
                                        }}
                                        alt="ledger-image"
                                      />
                                    </div>
                                  )}
                                </div>
                              </li>
                              <li className="field-li row">
                                <div
                                  className="col-md-2"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  Page number
                                </div>
                                <div className="col-md-10">
                                  <p>{objectData?.page_number}</p>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div
                                  className="col-md-2"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  Old accession number
                                </div>
                                <div className="col-md-10">
                                  <p>{objectData?.old_accession_number}</p>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div
                                  className="col-md-2"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  Page image
                                </div>
                                <div className="col-md-10">
                                  {objectData?.page_image && (
                                    <div
                                      style={{
                                        height: "100px",
                                        width: "100px",
                                        borderRadius: "10px",
                                        border: "1px solid rgb(238, 238, 238)",
                                        padding: "5px",
                                      }}
                                    >
                                      <img
                                        onClick={() => {
                                          setShowEnlargeImage({
                                            show: true,
                                            image: objectData?.page_image,
                                            isEdit: false,
                                            title: "Page image",
                                          });
                                        }}
                                        src={objectData?.page_image}
                                        style={{
                                          height: "100%",
                                          width: "100%",
                                          objectFit: "contain",
                                        }}
                                        alt="page-image"
                                      />
                                    </div>
                                  )}
                                </div>
                              </li>
                              <li className="field-li row">
                                <div
                                  className="col-md-2"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  Ledger entry description
                                </div>
                                <div className="col-md-10">
                                  <p>{objectData?.ledger_description}</p>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div
                                  className="col-md-2"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  Ledger entry translation
                                </div>
                                <div className="col-md-10">
                                  <p>{objectData?.ledger_translation}</p>
                                </div>
                              </li>
                              <li className="field-li row">
                                <div
                                  className="col-md-2"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  Ledger notes
                                </div>
                                <div className="col-md-10">
                                  <p>{objectData?.ledger_notes}</p>
                                </div>
                              </li>

                              <li className="field-li row">
                                <div
                                  className="col-md-2"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  Ledger entry images
                                </div>
                                <div
                                  className="col-md-10"
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {objectData?.ledger_entry_images?.map(
                                    (liEntry) => (
                                      <div
                                        style={{
                                          height: "100px",
                                          width: "100px",
                                          borderRadius: "10px",
                                          border:
                                            "1px solid rgb(238, 238, 238)",
                                          padding: "5px",
                                        }}
                                      >
                                        <img
                                          style={{
                                            height: "100%",
                                            width: "100%",
                                            objectFit: "contain",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            const reorderedImages = [
                                              liEntry,
                                              ...objectData?.ledger_entry_images.filter(
                                                (img) =>
                                                  img.entry_image !==
                                                  liEntry.entry_image
                                              ),
                                            ];
                                            setShowEnlargeImage({
                                              show: true,
                                              image: reorderedImages,
                                              isEdit: false,
                                              title: "Entry image",
                                            });
                                          }}
                                          src={liEntry?.entry_image}
                                          alt="entry-image"
                                        />
                                      </div>
                                    )
                                  )}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    <Accordion ref={stabilityCurrentRef}>
                      <Accordion.Item>
                        <Accordion.Header
                          style={{
                            borderBottom: "1px solid lightgray",
                            zIndex: 0,
                            position: "relative",
                          }}
                        >
                          <h6
                            style={{ fontWeight: "600", marginLeft: "-20px" }}
                          >
                            Condition grading
                          </h6>
                        </Accordion.Header>
                        <Accordion.Body style={{ marginLeft: "0px" }}>
                          <div
                            className="stability-container"
                            style={{ marginTop: "30px" }}
                          >
                            <div className="stability-box">
                              <div className="stability-count">
                                <div className="count-header">
                                  <p>
                                    Condition grading{" "}
                                    <span className="required">
                                      <sup>*</sup>
                                    </span>
                                  </p>
                                </div>
                                <div className="count-box">
                                  <p
                                    style={{
                                      backgroundColor:
                                        formik?.values?.stability === 1
                                          ? "green"
                                          : "",
                                      color:
                                        formik?.values?.stability === 1
                                          ? "#fff"
                                          : "",
                                    }}
                                    onClick={() => stabilityHandler(1)}
                                  >
                                    1
                                  </p>
                                  <p
                                    style={{
                                      backgroundColor:
                                        formik?.values?.stability === 2
                                          ? "#FEBE10"
                                          : "",
                                      color:
                                        formik?.values?.stability === 2
                                          ? "#fff"
                                          : "",
                                    }}
                                    onClick={() => stabilityHandler(2)}
                                  >
                                    2
                                  </p>
                                  <p
                                    style={{
                                      backgroundColor:
                                        formik?.values?.stability === 3
                                          ? "orangered"
                                          : "",
                                      color:
                                        formik?.values?.stability === 3
                                          ? "#fff"
                                          : "",
                                    }}
                                    onClick={() => stabilityHandler(3)}
                                  >
                                    3
                                  </p>
                                  <button
                                    type="button"
                                    style={{
                                      backgroundColor: formik?.values
                                        ?.is_emergency
                                        ? "#851A1A"
                                        : "#fff",
                                      color: formik?.values?.is_emergency
                                        ? "#fff"
                                        : "#000",
                                      border: formik?.values?.is_emergency
                                        ? "none"
                                        : "1px solid black",
                                      height: "45px",
                                    }}
                                    onClick={() =>
                                      isEmeregncyHandler("Emergency")
                                    }
                                  >
                                    Emergency
                                  </button>
                                </div>
                                {formik?.errors?.stability &&
                                  formik?.touched?.stability && (
                                    <p
                                      style={{
                                        fontSize: "0.9rem",
                                        color: "red",
                                      }}
                                    >
                                      {formik?.errors?.stability}
                                    </p>
                                  )}
                              </div>
                              <Row className="stabilization-container-row">
                                <Col lg={12} style={{ marginLeft: "0px" }}>
                                  <Form.Group>
                                    <Form.Label style={{ fontWeight: "600" }}>
                                      Remarks
                                      <span className="required">
                                        <sup>*</sup>
                                      </span>
                                    </Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      onChange={(e) => {
                                        formik?.handleChange(e);
                                        setIsAutoSave(true);
                                      }}
                                      name="remarks"
                                      value={formik?.values?.remarks}
                                      placeholder="Remarks"
                                      isInvalid={
                                        formik?.touched?.remarks &&
                                        !!formik?.errors?.remarks
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {formik?.errors?.remarks}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                {/* <Col lg={4} style={{ marginLeft: "0px" }}>
                                                                    <Form.Group>
                                                                        <Form.Label style={{ fontWeight: "600" }}>Object handling guidelines<span className='required'><sup>*</sup></span></Form.Label>
                                                                        <Form.Control
                                                                            as="textarea" s
                                                                            onChange={formik?.handleChange}
                                                                            name='object_handling_guidelines'
                                                                            value={formik?.values?.object_handling_guidelines}
                                                                            placeholder='Object handling guidelines'
                                                                            isInvalid={formik?.touched?.object_handling_guidelines && !!formik?.errors?.object_handling_guidelines}
                                                                        />
                                                                        <Form.Control.Feedback type='invalid'>{formik?.errors?.object_handling_guidelines}</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col> */}
                              </Row>
                              {!showContinue && (
                                <div className="next-button">
                                  {/* <Button type='submit' className='continue' onClick={() => { setAdddraft(true); formik?.handleSubmit() }}>Continue</Button> */}
                                  <Button
                                    type="button"
                                    className="continue"
                                    onClick={() => handleBack("discard")}
                                  >
                                    Discard changes
                                  </Button>

                                  <Button
                                    type="button"
                                    className="continue"
                                    onClick={() => {
                                      continueSubmitHandler("continue");
                                    }}
                                  >
                                    {buttonloader.continue ? (
                                      <SimpleBackdrop />
                                    ) : (
                                      "Continue"
                                    )}
                                  </Button>
                                </div>
                              )}
                            </div>
                            {showContinue && (
                              <div className="graphic-container">
                                <div className="count-header">
                                  <p>Graphical description</p>
                                </div>
                                <div className="img-main-box cons-img-main-box">
                                  <div
                                    className="img-adding-div conservat-img-div "
                                    onMouseDown={(e) => {
                                      if (e.detail > 1) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onClick={graphicRepresentHandler}
                                    style={{ marginTop: "30px" }}
                                  >
                                    <HiOutlinePlus
                                      size={70}
                                      color="#092159e4"
                                    />
                                  </div>
                                  {formik?.values?.graphical_represenatation.map(
                                    (li, indexOfgraph) => {
                                      return (
                                        <div
                                          key={indexOfgraph}
                                          className="image-graph-container"
                                          onClick={
                                            li?.image
                                              ? () =>
                                                  setShowEnlargeImage({
                                                    show: true,
                                                    title:
                                                      "Graphical description",
                                                    image: li?.image,
                                                    imageIdTitle:
                                                      "file-input-graph",
                                                    imageIndex: indexOfgraph,
                                                    isEdit: true,
                                                  })
                                              : () =>
                                                  document
                                                    .getElementById(
                                                      `file-input-graph-${indexOfgraph}`
                                                    )
                                                    .click()
                                          }
                                        >
                                          {li?.image ? (
                                            <div className="image-graph-saved-container">
                                              <img
                                                height={"100%"}
                                                width={"100%"}
                                                style={{ objectFit: "contain" }}
                                                src={li.image}
                                                alt="image-graph"
                                              />
                                            </div>
                                          ) : (
                                            <div className="img-upload">
                                              <div className="replace-logo-div">
                                                <img
                                                  className="replace-logo"
                                                  src={replace}
                                                  alt="logo"
                                                ></img>
                                              </div>
                                            </div>
                                          )}
                                          <Form.Control
                                            type="file"
                                            id={`file-input-graph-${indexOfgraph}`}
                                            style={{ display: "none" }}
                                            className="reference-image"
                                            onChange={(e) => {
                                              graphicImageAddhandler(
                                                e,
                                                indexOfgraph
                                              );
                                            }}
                                            accept=".jpeg,.jpg,.png"
                                          />
                                          <div
                                            className="delete_icon-cons"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              removeGraphicHandler(
                                                indexOfgraph
                                              );
                                            }}
                                          >
                                            <RiCloseFill
                                              // onClick={() => imageDeleteHandler(indexImage)}
                                              size={15}
                                              style={{ strokeWidth: 2 }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>

                                <Row className="stabilization-container-row">
                                  <Col
                                    lg={12}
                                    style={{
                                      marginLeft: "0px",
                                      marginBottom: "-22px",
                                    }}
                                  >
                                    <Form.Group>
                                      <Form.Label style={{ fontWeight: "600" }}>
                                        Physical description
                                      </Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        onChange={(e) => {
                                          formik?.handleChange(e);
                                          setIsAutoSave(true);
                                        }}
                                        name="physical_description"
                                        value={
                                          formik?.values?.physical_description
                                        }
                                        placeholder="Physical description"
                                      />
                                    </Form.Group>
                                  </Col>
                                  {/* <Col lg={4} style={{ marginLeft: "0px" }}>
                                                                    <Form.Group>
                                                                        <Form.Label style={{ fontWeight: "600" }}>Object handling guidelines<span className='required'><sup>*</sup></span></Form.Label>
                                                                        <Form.Control
                                                                            as="textarea" s
                                                                            onChange={formik?.handleChange}
                                                                            name='object_handling_guidelines'
                                                                            value={formik?.values?.object_handling_guidelines}
                                                                            placeholder='Object handling guidelines'
                                                                            isInvalid={formik?.touched?.object_handling_guidelines && !!formik?.errors?.object_handling_guidelines}
                                                                        />
                                                                        <Form.Control.Feedback type='invalid'>{formik?.errors?.object_handling_guidelines}</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col> */}
                                </Row>
                                <Row className="stabilization-container-row">
                                  <Col lg={12} style={{ marginLeft: "0px" }}>
                                    <Form.Group>
                                      <Form.Label style={{ fontWeight: "600" }}>
                                        {" "}
                                        Material technique
                                      </Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        onChange={(e) => {
                                          formik?.handleChange(e);
                                          setIsAutoSave(true);
                                        }}
                                        name="techinques_used"
                                        value={formik?.values?.techinques_used}
                                        placeholder="Material technique"
                                      />
                                    </Form.Group>
                                  </Col>
                                  {/* <Col lg={4} style={{ marginLeft: "0px" }}>
                                                                    <Form.Group>
                                                                        <Form.Label style={{ fontWeight: "600" }}>Object handling guidelines<span className='required'><sup>*</sup></span></Form.Label>
                                                                        <Form.Control
                                                                            as="textarea" s
                                                                            onChange={formik?.handleChange}
                                                                            name='object_handling_guidelines'
                                                                            value={formik?.values?.object_handling_guidelines}
                                                                            placeholder='Object handling guidelines'
                                                                            isInvalid={formik?.touched?.object_handling_guidelines && !!formik?.errors?.object_handling_guidelines}
                                                                        />
                                                                        <Form.Control.Feedback type='invalid'>{formik?.errors?.object_handling_guidelines}</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col> */}
                                </Row>
                              </div>
                            )}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    {showContinue && (
                      <>
                        <Accordion>
                          <Accordion.Item>
                            <Accordion.Header
                              style={{
                                borderBottom: "1px solid lightgray",
                                zIndex: 0,
                                position: "relative",
                              }}
                            >
                              <h6
                                style={{
                                  fontWeight: "600",
                                  marginLeft: "-20px",
                                }}
                              >
                                Condition assessment
                              </h6>
                            </Accordion.Header>

                            <Accordion.Body style={{ marginLeft: "10px" }}>
                              {technicalImages?.length > 0 && showS3Gallery && (
                                <ConservationGallery
                                  setShowS3Gallery={setShowS3Gallery}
                                  technicalImages={technicalImages}
                                />
                              )}
                              <ConditionAssessment
                                updateS3={updateS3}
                                setUpdateS3={setUpdateS3}
                                fromTable={fromList}
                                titleRowRef={titleRowRef}
                                technicalImages={technicalImages}
                                setIsAutoSave={setIsAutoSave}
                                setShowS3Gallery={setShowS3Gallery}
                                setUpdate={setUpdate}
                                update={update}
                                removestrategicEvidenceImageChangeHandler={
                                  removestrategicEvidenceImageChangeHandler
                                }
                                strategicEvidenceImageChangeHandler={
                                  strategicEvidenceImageChangeHandler
                                }
                                graphicImageAddhandler={graphicImageAddhandler}
                                strategicEvidenceImageAddHandler={
                                  strategicEvidenceImageAddHandler
                                }
                                strategicDetailRemoveHandler={
                                  strategicDetailRemoveHandler
                                }
                                strategicDetailsAddHandler={
                                  strategicDetailsAddHandler
                                }
                                conditionDegradationBlur={
                                  conditionDegradationBlur
                                }
                                stratRef={stratRef}
                                conditionDegradationChangeHandler={
                                  conditionDegradationChangeHandler
                                }
                                removeStratighicHandler={
                                  removeStratighicHandler
                                }
                                changeStratNameHandler={changeStratNameHandler}
                                stratNameChangeHandler={stratNameChangeHandler}
                                stratigraphicAddhandler={
                                  stratigraphicAddhandler
                                }
                                formik={formik}
                                setShowEnlargeImage={setShowEnlargeImage}
                              />
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                        <Accordion>
                          <Accordion.Item>
                            <Accordion.Header
                              style={{
                                borderBottom: "1px solid lightgray",
                                zIndex: 0,
                                position: "relative",
                              }}
                            >
                              <h6
                                style={{
                                  fontWeight: "600",
                                  marginLeft: "-20px",
                                }}
                              >
                                Investigation and analysis
                              </h6>
                            </Accordion.Header>
                            <Accordion.Body style={{ marginLeft: "0px" }}>
                              {formik?.values?.investigation_details?.map(
                                (investigationValue, investigationIndex) => {
                                  return (
                                    <Row className="investigation-container">
                                      <Col lg={11}>
                                        <Row>
                                          <Col lg={3} md={6} sm={6} xs={12}>
                                            <Form.Group>
                                              <Form.Label>
                                                Investigation name
                                              </Form.Label>
                                              <Form.Control
                                                onChange={(e) =>
                                                  investNameChangeHandler(
                                                    e,
                                                    investigationIndex
                                                  )
                                                }
                                                value={
                                                  investigationValue?.investigation_name
                                                }
                                                name={`sample_details`}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col
                                            className="investigation-fields-first-row"
                                            lg={3}
                                            md={6}
                                            sm={6}
                                            xs={12}
                                          >
                                            <Form.Group>
                                              <Form.Label>
                                                Investigation ID
                                              </Form.Label>
                                              <Form.Control
                                                disabled
                                                value={
                                                  investigationValue?.investigation_id
                                                    ? investigationValue?.investigation_id
                                                    : " "
                                                }
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col
                                            className="investigation-fields-second-row"
                                            lg={3}
                                            md={6}
                                            sm={6}
                                            xs={12}
                                          >
                                            <Form.Group
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                              }}
                                            >
                                              <Form.Label>
                                                Invasive/ Non invasive
                                              </Form.Label>
                                              <IOSSwitch
                                                checked={
                                                  investigationValue?.invasive_or_non_vasive
                                                }
                                                //   value={investigationValue?.invasive_or_non_vasive}
                                                onChange={(e) =>
                                                  invasiveChangeHandler(
                                                    e,
                                                    investigationIndex
                                                  )
                                                }
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col
                                            className="investigation-fields-second-row"
                                            lg={3}
                                            md={6}
                                            sm={6}
                                            xs={12}
                                          >
                                            <Form.Group>
                                              <Form.Label>
                                                Sample details
                                              </Form.Label>
                                              <Form.Control
                                                onChange={(e) =>
                                                  investDetailHandler(
                                                    e,
                                                    investigationIndex
                                                  )
                                                }
                                                value={
                                                  investigationValue?.sample_details
                                                }
                                                name={`sample_details`}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col
                                            lg={3}
                                            md={6}
                                            sm={6}
                                            xs={12}
                                            style={{ marginTop: "20px" }}
                                          >
                                            <Form.Group>
                                              <Form.Label>Result</Form.Label>
                                              <Form.Control
                                                onChange={(e) =>
                                                  investResultHandler(
                                                    e,
                                                    investigationIndex
                                                  )
                                                }
                                                value={
                                                  investigationValue?.result
                                                }
                                                name={`result`}
                                              />
                                            </Form.Group>
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col
                                        style={{
                                          gap: "8px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                        lg={1}
                                      >
                                        {investigationIndex === 0 && (
                                          <svg
                                            onClick={() =>
                                              investigationAddHandler()
                                            }
                                            style={{ cursor: "pointer" }}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="27"
                                            height="27"
                                            viewBox="0 0 27 27"
                                            fill="none"
                                          >
                                            <path
                                              d="M21.8657 12.8036H14.1969V5.13477H12.8026V12.8036H5.13379V14.1979H12.8026V21.8667H14.1969V14.1979H21.8657V12.8036Z"
                                              fill="#20409A"
                                            />
                                            <circle
                                              cx="13.5"
                                              cy="13.5"
                                              r="12.75"
                                              stroke="#20409A"
                                              stroke-width="1.5"
                                            />
                                          </svg>
                                        )}
                                        {formik?.values?.investigation_details
                                          ?.length > 1 && (
                                          <CiCircleMinus
                                            onClick={() =>
                                              investigationRemoveHandler(
                                                investigationIndex
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              color: "rgb(32, 64, 154)",
                                              fontSize: "32px",
                                            }}
                                          />
                                        )}
                                      </Col>
                                    </Row>
                                  );
                                }
                              )}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                        <Accordion>
                          <Accordion.Item>
                            <Accordion.Header
                              style={{
                                borderBottom: "1px solid lightgray",
                                zIndex: 0,
                                position: "relative",
                              }}
                            >
                              <h6
                                style={{
                                  fontWeight: "600",
                                  marginLeft: "-20px",
                                }}
                              >
                                Proposed treatment
                              </h6>
                            </Accordion.Header>
                            <Accordion.Body style={{ marginLeft: "0px" }}>
                              <div className="proposed-container">
                                <div className="proposed-header">
                                  {/* <p>Proposed treatment</p> */}
                                </div>

                                {formik?.values?.proposed_treatment?.map(
                                  (values, proposedIndex) => {
                                    return (
                                      <div style={{ marginBottom: "60px" }}>
                                        <div className="proposed-log-view"></div>
                                        <Row style={{ display: "flex" }}>
                                          <Col lg={1} md={2} sm={4} xs={4}>
                                            <Form.Group>
                                              <Form.Label>Step</Form.Label>
                                              <Form.Control
                                                value={values?.step}
                                                onChange={(e) => {
                                                  formik?.handleChange(e);
                                                  setIsAutoSave(true);
                                                }}
                                                maxLength={3}
                                                name={`proposed_treatment[${proposedIndex}].step`}
                                                onKeyDown={(e) => {
                                                  const allowedKeys = [
                                                    "Backspace",
                                                    "Tab",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Delete",
                                                  ];
                                                  if (
                                                    !/^\d$/.test(e.key) &&
                                                    !allowedKeys.includes(e.key)
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col lg={10} md={10} sm={12} xs={12}>
                                            <Row>
                                              <Col
                                                className="proposed-task-field-first-row"
                                                lg={4}
                                                md={6}
                                              >
                                                <Form.Group>
                                                  <Form.Label>
                                                    Degradation
                                                  </Form.Label>
                                                  <AsyncSelect
                                                    components={
                                                      customComponents
                                                    }
                                                    defaultOptions={degradation?.map(
                                                      (itemDegrad) => {
                                                        return {
                                                          ...itemDegrad,
                                                          label: capitalizeWord(
                                                            itemDegrad?.label
                                                          ),
                                                        };
                                                      }
                                                    )}
                                                    loadOptions={
                                                      degradationLoadOptionHandler
                                                    }
                                                    value={
                                                      values?.selectedDegradation
                                                        ? values?.selectedDegradation
                                                        : values?.degradation
                                                        ? {
                                                            value:
                                                              values?.degradation,
                                                            label: `${values?.degradation_name} (${values?.assessment_name})`,
                                                          }
                                                        : null
                                                    }
                                                    onChange={(e) =>
                                                      degradationChangeHandler(
                                                        e,
                                                        proposedIndex
                                                      )
                                                    }
                                                    onInputChange={(
                                                      newValue,
                                                      { action }
                                                    ) => {
                                                      if (
                                                        action ===
                                                          "input-change" &&
                                                        newValue === ""
                                                      ) {
                                                        setDegradation(
                                                          defaultDegradation
                                                        ); // Reset to default options
                                                      }
                                                    }}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col
                                                lg={4}
                                                md={6}
                                                className="proposed-task-field-first-row"
                                              >
                                                <div className="action-container">
                                                  <Form.Group>
                                                    <Form.Label>
                                                      <p>Action</p>
                                                      {values?.actionAdd ? (
                                                        <Tooltip
                                                          placement="top"
                                                          title="Back to treatment action options"
                                                        >
                                                          <div>
                                                            <MdOutlineArrowBack
                                                              className="back-action"
                                                              onClick={() =>
                                                                backToTreatmentHandler(
                                                                  proposedIndex
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        </Tooltip>
                                                      ) : (
                                                        <Tooltip
                                                          placement="top"
                                                          title="Add a treatment action and press 'Enter' to save."
                                                        >
                                                          <div>
                                                            <GoPlusCircle
                                                              onClick={() =>
                                                                addTreatmentActionHandler(
                                                                  proposedIndex
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        </Tooltip>
                                                      )}
                                                    </Form.Label>
                                                    {values?.actionAdd ||
                                                    showAction ? (
                                                      <Form.Control
                                                        ref={(e) =>
                                                          (refs.current[
                                                            proposedIndex
                                                          ] = e)
                                                        }
                                                        placeholder="Add treatment action"
                                                        // onChange={(e) => setTreatmentValue(e?.target?.value)}
                                                        onKeyDown={(e) =>
                                                          addActionChangeHandler(
                                                            e,
                                                            proposedIndex
                                                          )
                                                        }
                                                        autoFocus
                                                      />
                                                    ) : (
                                                      <AsyncSelect
                                                        loadOptions={
                                                          actionLoadOption
                                                        }
                                                        defaultOptions={action}
                                                        components={
                                                          customactionComponent
                                                        }
                                                        onChange={(e) =>
                                                          actionValueAddHandler(
                                                            e,
                                                            proposedIndex
                                                          )
                                                        }
                                                        value={
                                                          values?.selectedAction
                                                            ? values?.selectedAction
                                                            : {
                                                                value:
                                                                  values?.action,
                                                                label:
                                                                  values?.action_name,
                                                              }
                                                        }
                                                        onInputChange={(
                                                          newValue,
                                                          { action }
                                                        ) => {
                                                          setActionNewValue(
                                                            newValue
                                                          );
                                                          if (
                                                            action ===
                                                              "input-change" &&
                                                            newValue === ""
                                                          ) {
                                                            setAction(
                                                              defaultAction
                                                            ); // Reset to default options
                                                          }
                                                        }}
                                                      />
                                                    )}
                                                  </Form.Group>
                                                </div>
                                              </Col>
                                              <Col
                                                className="proposed-task-field-second-row"
                                                lg={4}
                                                md={6}
                                              >
                                                <Form.Group>
                                                  <Form.Label>Task</Form.Label>
                                                  <Form.Control
                                                    as="textarea"
                                                    onChange={(e) => {
                                                      formik?.handleChange(e);
                                                      setIsAutoSave(true);
                                                    }}
                                                    value={values?.task}
                                                    name={`proposed_treatment[${proposedIndex}].task`}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col
                                                style={{
                                                  marginTop: "20px",
                                                }}
                                                lg={4}
                                                md={6}
                                              >
                                                <Form.Group>
                                                  <Form.Label>
                                                    Conservation material
                                                  </Form.Label>
                                                  <Form.Control
                                                    placeholder="Conservation material"
                                                    onChange={(e) =>
                                                      conservationMaterialHandler(
                                                        e,
                                                        proposedIndex
                                                      )
                                                    }
                                                    value={
                                                      values?.conservation_materials
                                                    }
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col
                                                style={{
                                                  marginTop: "20px",
                                                }}
                                                lg={4}
                                                md={6}
                                              >
                                                <Form.Group className="proposed-status-field">
                                                  <Form.Label>
                                                    Status
                                                  </Form.Label>
                                                  <Select
                                                    options={
                                                      values?.selectedAction ||
                                                      values?.action
                                                        ? [
                                                            {
                                                              value: "To-do",
                                                              label: "To-do",
                                                            },
                                                            {
                                                              value: "Started",
                                                              label: "Started",
                                                            },
                                                            {
                                                              value:
                                                                "In progress",
                                                              label:
                                                                "In progress",
                                                            },
                                                            {
                                                              value: "Done",
                                                              label: "Done",
                                                            },
                                                          ]
                                                        : []
                                                    }
                                                    value={{
                                                      value: values?.status,
                                                      label: values?.status,
                                                    }}
                                                    onChange={(e) =>
                                                      statusChangeHandler(
                                                        e,
                                                        proposedIndex
                                                      )
                                                    }
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col
                                                style={{
                                                  marginTop: "20px",
                                                }}
                                                lg={4}
                                                md={6}
                                              >
                                                <Form.Group
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <Form.Label>
                                                    Make standard procedure
                                                  </Form.Label>
                                                  <IOSSwitch
                                                    onChange={(e) =>
                                                      procedureHandler(
                                                        e,
                                                        proposedIndex
                                                      )
                                                    }
                                                    checked={
                                                      values?.is_standered_procedure
                                                        ? values?.is_standered_procedure
                                                        : false
                                                    }
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                          </Col>
                                          <Col
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-end",
                                              marginBottom: "20px",
                                            }}
                                            lg={1}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="proposed-icons-container"
                                          >
                                            <div
                                              className="proposed-icons"
                                              style={{
                                                display: "flex",
                                                gap: "8px",
                                                alignItems: "center",
                                              }}
                                            >
                                              {(values?.status === "Started" ||
                                                values?.status ===
                                                  "In progress" ||
                                                values?.status === "Done") && (
                                                <Tooltip
                                                  title={
                                                    values?.viewLog
                                                      ? "Close treatment log"
                                                      : "View treatment log"
                                                  }
                                                >
                                                  <div
                                                    onClick={() =>
                                                      viewLogHandler(
                                                        proposedIndex
                                                      )
                                                    }
                                                  >
                                                    <IoMdEye
                                                      className="view-icon"
                                                      style={{
                                                        color: "#20409A",
                                                        fontSize: "32px",
                                                        cursor: "pointer",
                                                      }}
                                                    />
                                                  </div>
                                                </Tooltip>
                                              )}
                                              {formik?.values
                                                ?.proposed_treatment.length -
                                                1 ===
                                                proposedIndex && (
                                                <svg
                                                  onClick={() =>
                                                    addProposedTreatmentHandler(
                                                      proposedIndex
                                                    )
                                                  }
                                                  style={{ cursor: "pointer" }}
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="27"
                                                  height="27"
                                                  viewBox="0 0 27 27"
                                                  fill="none"
                                                >
                                                  <path
                                                    d="M21.8657 12.8036H14.1969V5.13477H12.8026V12.8036H5.13379V14.1979H12.8026V21.8667H14.1969V14.1979H21.8657V12.8036Z"
                                                    fill="#20409A"
                                                  />
                                                  <circle
                                                    cx="13.5"
                                                    cy="13.5"
                                                    r="12.75"
                                                    stroke="#20409A"
                                                    stroke-width="1.5"
                                                  />
                                                </svg>
                                              )}
                                              {formik?.values
                                                ?.proposed_treatment?.length >
                                                1 && (
                                                <CiCircleMinus
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "rgb(32, 64, 154)",
                                                    fontSize: "32px",
                                                  }}
                                                  onClick={() =>
                                                    removeProposedHandler(
                                                      proposedIndex
                                                    )
                                                  }
                                                />
                                              )}
                                            </div>
                                          </Col>
                                        </Row>
                                        {values?.viewLog &&
                                          (values.status === "Started" ||
                                            values.status === "In progress" ||
                                            values.status === "To-do" ||
                                            values.status === "Done") &&
                                          values?.treatment_log?.map(
                                            (logValue, logIndex) => (
                                              <Row className="propose-log-row">
                                                <div
                                                  className="treatment-title"
                                                  style={{
                                                    marginBottom: "10px",
                                                  }}
                                                >
                                                  {logIndex === 0 && (
                                                    <h6
                                                      style={{
                                                        fontWeight: "600",
                                                      }}
                                                    >
                                                      Treatment log
                                                    </h6>
                                                  )}
                                                </div>
                                                <Col lg={3} md={6}>
                                                  <div>
                                                    <p
                                                      style={{
                                                        paddingBottom: "9px",
                                                      }}
                                                    >
                                                      Date
                                                    </p>
                                                    <Space
                                                      style={{ width: "100%" }}
                                                    >
                                                      <DatePicker
                                                        onChange={(e) =>
                                                          logDateHandler(
                                                            e,
                                                            proposedIndex,
                                                            logIndex
                                                          )
                                                        }
                                                        style={{
                                                          padding:
                                                            ".375rem .75rem",
                                                          width: "100%",
                                                        }}
                                                        value={
                                                          logValue?.date
                                                            ? dayjs(
                                                                logValue?.date
                                                              )
                                                            : null
                                                        }
                                                        format="DD-MM-YYYY"
                                                      />
                                                    </Space>
                                                  </div>
                                                </Col>

                                                <Col
                                                  className="propose-log-first-row"
                                                  lg={4}
                                                  md={6}
                                                >
                                                  <Form.Group>
                                                    <Form.Label>
                                                      Notes
                                                    </Form.Label>
                                                    <Form.Control
                                                      onChange={(e) => {
                                                        formik?.handleChange(e);
                                                        setIsAutoSave(true);
                                                      }}
                                                      value={logValue?.notes}
                                                      name={`proposed_treatment[${proposedIndex}].treatment_log[${logIndex}].notes`}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col
                                                  lg={5}
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                  }}
                                                  className="proposed-log-image-box"
                                                >
                                                  <div className="propose-log-second-row">
                                                    <div>
                                                      <p>Evidence</p>
                                                    </div>
                                                    <div className="propse-log-image-box">
                                                      <div
                                                        className="img-adding-div conservat-img-div-propose "
                                                        onMouseDown={(e) => {
                                                          if (e.detail > 1) {
                                                            e.preventDefault();
                                                          }
                                                        }}
                                                        onClick={() =>
                                                          addProposeLogImageHandler(
                                                            proposedIndex,
                                                            logIndex
                                                          )
                                                        }
                                                        style={{
                                                          marginTop: "9px",
                                                        }}
                                                      >
                                                        <HiOutlinePlus
                                                          size={70}
                                                          color="#092159e4"
                                                        />
                                                      </div>

                                                      {logValue?.evidence?.map(
                                                        (li, indexOfEvid) => {
                                                          return (
                                                            <>
                                                              <div
                                                                className="img-upload-propose"
                                                                onClick={() => {
                                                                  if (
                                                                    li?.image
                                                                  ) {
                                                                    setShowEnlargeImage(
                                                                      {
                                                                        title:
                                                                          "Proposed treatment",
                                                                        show: true,
                                                                        image:
                                                                          li?.image,
                                                                        parentIndex:
                                                                          proposedIndex,
                                                                        childIndex:
                                                                          logIndex,
                                                                        imageIndex:
                                                                          indexOfEvid,
                                                                        imageIdTitle:
                                                                          "file-input-treatment",
                                                                        isEdit: true,
                                                                      }
                                                                    );
                                                                  } else {
                                                                    document
                                                                      .getElementById(
                                                                        `file-input-treatment-${proposedIndex}-${logIndex}-${indexOfEvid}`
                                                                      )
                                                                      .click();
                                                                  }
                                                                }}
                                                              >
                                                                {li?.image ? (
                                                                  <img
                                                                    style={{
                                                                      height:
                                                                        "100%",
                                                                      width:
                                                                        "100%",
                                                                      objectFit:
                                                                        "contain",
                                                                    }}
                                                                    src={
                                                                      li?.image
                                                                    }
                                                                    alt="image-screen"
                                                                  />
                                                                ) : (
                                                                  <div className="replace-logo-div">
                                                                    <img
                                                                      className="replace-logo"
                                                                      src={
                                                                        replace
                                                                      }
                                                                      alt="replace"
                                                                    ></img>
                                                                  </div>
                                                                )}
                                                                <div
                                                                  className="delete_icon-cons"
                                                                  onClick={(
                                                                    e
                                                                  ) => {
                                                                    e.stopPropagation();
                                                                    removeLogImageChangeHandler(
                                                                      proposedIndex,
                                                                      logIndex,
                                                                      indexOfEvid
                                                                    );
                                                                  }}
                                                                >
                                                                  <RiCloseFill
                                                                    // onClick={() => imageDeleteHandler(indexImage)}
                                                                    size={15}
                                                                    style={{
                                                                      strokeWidth: 2,
                                                                    }}
                                                                  />
                                                                </div>
                                                              </div>
                                                              <Form.Control
                                                                type="file"
                                                                id={`file-input-treatment-${proposedIndex}-${logIndex}-${indexOfEvid}`}
                                                                style={{
                                                                  display:
                                                                    "none",
                                                                }}
                                                                onChange={(e) =>
                                                                  addLogImageChangeHandler(
                                                                    e,
                                                                    proposedIndex,
                                                                    logIndex,
                                                                    indexOfEvid
                                                                  )
                                                                }
                                                                accept=".jpeg,.jpg,.png"
                                                              />
                                                            </>
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                      className="proposed-log-image-box-icons"
                                                    >
                                                      {logIndex === 0 && (
                                                        <svg
                                                          onClick={() =>
                                                            AddProposedHandler(
                                                              proposedIndex
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="27"
                                                          height="27"
                                                          viewBox="0 0 27 27"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M21.8657 12.8036H14.1969V5.13477H12.8026V12.8036H5.13379V14.1979H12.8026V21.8667H14.1969V14.1979H21.8657V12.8036Z"
                                                            fill="#20409A"
                                                          />
                                                          <circle
                                                            cx="13.5"
                                                            cy="13.5"
                                                            r="12.75"
                                                            stroke="#20409A"
                                                            stroke-width="1.5"
                                                          />
                                                        </svg>
                                                      )}

                                                      {formik?.values
                                                        ?.proposed_treatment[
                                                        proposedIndex
                                                      ]?.treatment_log?.length >
                                                        1 && (
                                                        <CiCircleMinus
                                                          style={{
                                                            fontSize: "31px",
                                                            color: "#20409A",
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() =>
                                                            removedProposedHandler(
                                                              proposedIndex,
                                                              logIndex
                                                            )
                                                          }
                                                        />
                                                      )}
                                                    </div>
                                                  </div>
                                                </Col>
                                              </Row>
                                            )
                                          )}
                                        {values?.viewLog &&
                                          (values.status === "Started" ||
                                            values.status === "In progress" ||
                                            values.status === "To-do" ||
                                            values.status === "Done") && (
                                            <div
                                              className="proposed-button"
                                              style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                marginTop: "10px",
                                              }}
                                            >
                                              <Button
                                                type="button"
                                                onClick={() =>
                                                  addStepCompleteHandler(
                                                    proposedIndex
                                                  )
                                                }
                                                style={{
                                                  backgroundColor: "#20409A",
                                                }}
                                              >
                                                Step complete
                                              </Button>
                                            </div>
                                          )}
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                        {formik?.values?.proposed_treatment[0].status ===
                          "Done" && (
                          <Accordion>
                            <Accordion.Item>
                              <Accordion.Header
                                style={{
                                  borderBottom: "1px solid lightgray",
                                  zIndex: 0,
                                  position: "relative",
                                }}
                              >
                                <h6
                                  style={{
                                    fontWeight: "600",
                                    marginLeft: "-20px",
                                  }}
                                >
                                  Recommended storage
                                </h6>
                              </Accordion.Header>
                              <Accordion.Body style={{ marginLeft: "0px" }}>
                                <div className="Recommended-container">
                                  <div className="recommended-header">
                                    {/* <p>Recommended storage</p> */}
                                  </div>
                                  <Row>
                                    <Form.Group>
                                      <Form.Control
                                        as="textarea"
                                        rows={5}
                                        value={
                                          formik?.values?.recommended_storage
                                        }
                                        name={`recommended_storage`}
                                        onChange={(e) => {
                                          formik?.handleChange(e);
                                          setIsAutoSave(true);
                                        }}
                                      />
                                    </Form.Group>
                                  </Row>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        )}
                      </>
                    )}
                  </div>
                </Row>
              </div>
              {showContinue && (
                <>
                  <div className="submit-btn-row" style={{ flexWrap: "wrap" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: "20px",
                        flexWrap: "wrap",
                        justifyContent: "end",
                      }}
                    >
                      <Button
                        style={{ height: "34px" }}
                        className="discard-btn"
                        onClick={() => handleBack("discard")}
                        // style={{ backgroundColor: "#20409A" }}
                        type="button"
                        disabled={buttonloader?.save}
                      >
                        Discard changes
                      </Button>
                      {formik?.values?.object_details?.conservation_status ===
                      "conservation_complete" ? (
                        hasFormChanged && (
                          <Button
                            style={{ height: "34px" }}
                            className="discard-btn"
                            onClick={onConervesubmitHandler}
                            // style={{ backgroundColor: "#20409A" }}
                            type="button"
                            disabled={buttonloader?.save}
                          >
                            {buttonloader?.save ? <SimpleBackdrop /> : "Save"}
                          </Button>
                        )
                      ) : (
                        <Button
                          style={{ height: "34px" }}
                          onClick={onConervesubmitHandler}
                          // style={{ backgroundColor: "#20409A" }}
                          className="discard-btn"
                          type="button"
                          disabled={buttonloader?.save}
                        >
                          {buttonloader?.save ? <SimpleBackdrop /> : "Save"}
                        </Button>
                      )}
                      {/* <Tooltip placement='top' title={!(enableValues?.stability && enableValues?.object_handling_guidelines && enableValues?.stabilization_guidelines && enableValues && enableValues?.recommended_storage) ? "Add Stability, Stabilization guidelines,Object handling guidelines,Recommended Storage" : ""}> */}
                    </div>
                    <Button
                      type="submit"
                      disabled={
                        !(
                          (enableValues?.stability ||
                            enableValues?.is_emergency) &&
                          enableValues?.remarks &&
                          enableValues?.recommended_storage
                        ) ||
                        !(enableValues?.stability || enableValues?.is_emergency)
                      }
                      style={{
                        cursor:
                          enableValues?.remarks &&
                          enableValues?.recommended_storage
                            ? "pointer"
                            : "not-allowed",
                        pointerEvents: "auto",
                      }}
                      className="submit-btn"
                    >
                      {buttonloader.complete ? (
                        <SimpleBackdrop />
                      ) : (
                        "Conservation completed"
                      )}
                    </Button>

                    {/* </Tooltip> */}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "end",
                      marginTop: "10px",
                    }}
                  >
                    {Object.keys(formik?.errors).filter(
                      (key) => formik?.touched[key]
                    ).length > 0 && (
                      <p style={{ color: "red" }}>
                        One or more required fields are missing, Please complete
                        them before submitting.
                      </p>
                    )}
                  </div>
                </>
              )}
              <Commentdrawer
                fromlist={fromList}
                id={id}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                toggleDrawer={toggleDrawer}
              />
              <Objecthistorydrawer
                fromList={fromList}
                id={id}
                isOpenhistory={isOpenhistory}
                setIsOpenhistory={setIsOpenhistory}
                toggleDrawerhistory={toggleDrawerhistory}
              />
            </Form>
          )}
          {isOverRide && (
            <OverRideAlert
              setIsOverRide={setIsOverRide}
              isOverRide={isOverRide}
              isOverideLoad={isOverideLoad}
              setLoading={setLoading}
              overRideCancel={overRideCancel}
              overRideConfirmHandler={overRideConfirmHandler}
            />
          )}
        </Container>
      </div>
    </section>
  );
};

export default Objectconsadd;
